export const sampleQuizQuestions = [
  {
    id: 1,
    question: "What is the capital of France?",
    options: ["Berlin", "Madrid", "Paris", "Rome"],
    answer: "Paris"
  },
  {
    id: 2,
    question: "Which planet is known as the Red Planet?",
    options: ["Venus", "Mars", "Jupiter", "Saturn"],
    answer: "Mars"
  },
  {
    id: 3,
    question: "What is 5 + 7 * 2?",
    options: ["24", "19", "17", "21"],
    answer: "19"
  },
  {
    id: 4,
    question: "Which programming language runs web browsers?",
    options: ["Python", "C++", "JavaScript", "Java"],
    answer: "JavaScript"
  },
  {
    id: 5,
    question: "What is the chemical symbol for Gold?",
    options: ["Ag", "Au", "Gd", "Pt"],
    answer: "Au"
  },
  {
    id: 6,
    question: "Who painted the Mona Lisa?",
    options: ["Vincent van Gogh", "Pablo Picasso", "Leonardo da Vinci", "Claude Monet"],
    answer: "Leonardo da Vinci"
  },
  {
    id: 7,
    question: "What is the largest ocean on Earth?",
    options: ["Atlantic Ocean", "Indian Ocean", "Arctic Ocean", "Pacific Ocean"],
    answer: "Pacific Ocean"
  },
  {
    id: 8,
    question: "In which year did World War II end?",
    options: ["1943", "1945", "1950", "1939"],
    answer: "1945"
  },
  {
    id: 9,
    question: "What is the powerhouse of the cell?",
    options: ["Nucleus", "Ribosome", "Mitochondria", "Endoplasmic Reticulum"],
    answer: "Mitochondria"
  },
  {
    id: 10,
    question: "How many continents are there on Earth?",
    options: ["5", "6", "7", "8"],
    answer: "7"
  },
  {
    id: 11,
    question: "What is the chemical symbol for Water?",
    options: ["H2O", "CO2", "NaCl", "O2"],
    answer: "H2O"
  },
  {
    id: 12,
    question: "Which gas do plants absorb from the atmosphere?",
    options: ["Oxygen", "Carbon Dioxide", "Nitrogen", "Hydrogen"],
    answer: "Carbon Dioxide"
  },
  {
    id: 13,
    question: "What is the fastest land animal?",
    options: ["Lion", "Cheetah", "Horse", "Leopard"],
    answer: "Cheetah"
  },
  {
    id: 14,
    question: "How many bones are in the adult human body?",
    options: ["206", "210", "195", "220"],
    answer: "206"
  },
  {
    id: 15,
    question: "What is the boiling point of water in Celsius?",
    options: ["90°C", "100°C", "110°C", "120°C"],
    answer: "100°C"
  },
  {
    id: 16,
    question: "Who wrote 'Romeo and Juliet'?",
    options: ["Charles Dickens", "William Shakespeare", "Mark Twain", "Jane Austen"],
    answer: "William Shakespeare"
  },
  {
    id: 17,
    question: "What is the capital of Japan?",
    options: ["Seoul", "Beijing", "Tokyo", "Bangkok"],
    answer: "Tokyo"
  },
  {
    id: 18,
    question: "Which element has the atomic number 1?",
    options: ["Helium", "Hydrogen", "Oxygen", "Carbon"],
    answer: "Hydrogen"
  },
  {
    id: 19,
    question: "What is the largest mammal in the world?",
    options: ["African Elephant", "Blue Whale", "Giraffe", "Polar Bear"],
    answer: "Blue Whale"
  },
  {
    id: 20,
    question: "In what year did the Titanic sink?",
    options: ["1910", "1912", "1915", "1920"],
    answer: "1912"
  },
  {
    id: 21,
    question: "What is the square root of 144?",
    options: ["10", "11", "12", "14"],
    answer: "12"
  },
  {
    id: 22,
    question: "Which country is home to the kangaroo?",
    options: ["New Zealand", "South Africa", "Australia", "Brazil"],
    answer: "Australia"
  },
  {
    id: 23,
    question: "What is the hardest natural substance on Earth?",
    options: ["Gold", "Iron", "Diamond", "Platinum"],
    answer: "Diamond"
  },
  {
    id: 24,
    question: "Who discovered penicillin?",
    options: ["Alexander Fleming", "Marie Curie", "Albert Einstein", "Isaac Newton"],
    answer: "Alexander Fleming"
  },
  {
    id: 25,
    question: "What is the smallest prime number?",
    options: ["0", "1", "2", "3"],
    answer: "2"
  },
  {
    id: 26,
    question: "Which planet is closest to the Sun?",
    options: ["Venus", "Mercury", "Earth", "Mars"],
    answer: "Mercury"
  },
  {
    id: 27,
    question: "What is the primary currency of the United Kingdom?",
    options: ["Euro", "Dollar", "Pound Sterling", "Franc"],
    answer: "Pound Sterling"
  },
  {
    id: 28,
    question: "How many players are on the field for a soccer team?",
    options: ["9", "10", "11", "12"],
    answer: "11"
  },
  {
    id: 29,
    question: "What is the longest river in the world?",
    options: ["Amazon River", "Nile River", "Yangtze River", "Mississippi River"],
    answer: "Nile River"
  },
  {
    id: 30,
    question: "Which gas makes up the majority of Earth's atmosphere?",
    options: ["Oxygen", "Carbon Dioxide", "Nitrogen", "Argon"],
    answer: "Nitrogen"
  },
  {
    id: 31,
    question: "Who formulated the theory of relativity?",
    options: ["Isaac Newton", "Albert Einstein", "Galileo Galilei", "Nikola Tesla"],
    answer: "Albert Einstein"
  },
  {
    id: 32,
    question: "What is the capital of Italy?",
    options: ["Venice", "Florence", "Rome", "Milan"],
    answer: "Rome"
  },
  {
    id: 33,
    question: "Which vitamin is synthesized when human skin is exposed to sunlight?",
    options: ["Vitamin A", "Vitamin B", "Vitamin C", "Vitamin D"],
    answer: "Vitamin D"
  },
  {
    id: 34,
    question: "What is the main ingredient in guacamole?",
    options: ["Tomato", "Avocado", "Onion", "Pepper"],
    answer: "Avocado"
  },
  {
    id: 35,
    question: "How many sides does a hexagon have?",
    options: ["5", "6", "7", "8"],
    answer: "6"
  },
  {
    id: 36,
    question: "What year did the American Civil War end?",
    options: ["1863", "1865", "1870", "1872"],
    answer: "1865"
  },
  {
    id: 37,
    question: "Which instrument has 88 keys?",
    options: ["Guitar", "Violin", "Piano", "Flute"],
    answer: "Piano"
  },
  {
    id: 38,
    question: "What is the capital of Canada?",
    options: ["Toronto", "Vancouver", "Ottawa", "Montreal"],
    answer: "Ottawa"
  },
  {
    id: 39,
    question: "What is the chemical symbol for Iron?",
    options: ["Ir", "Fe", "In", "F"],
    answer: "Fe"
  },
  {
    id: 40,
    question: "Who painted 'Starry Night'?",
    options: ["Claude Monet", "Vincent van Gogh", "Pablo Picasso", "Salvador Dalí"],
    answer: "Vincent van Gogh"
  },
  {
    id: 41,
    question: "What is the freezing point of water in Fahrenheit?",
    options: ["0°F", "32°F", "50°F", "100°F"],
    answer: "32°F"
  },
  {
    id: 42,
    question: "Which planet is known as the Ringed Planet?",
    options: ["Jupiter", "Saturn", "Uranus", "Neptune"],
    answer: "Saturn"
  },
  {
    id: 43,
    question: "What is the largest desert in the world?",
    options: ["Sahara Desert", "Arabian Desert", "Antarctic Desert", "Gobi Desert"],
    answer: "Antarctic Desert"
  },
  {
    id: 44,
    question: "Which computer operating system was developed by Microsoft?",
    options: ["macOS", "Linux", "Windows", "Ubuntu"],
    answer: "Windows"
  },
  {
    id: 45,
    question: "What is the value of Pi rounded to two decimal places?",
    options: ["3.12", "3.14", "3.16", "3.18"],
    answer: "3.14"
  },
  {
    id: 46,
    question: "Who was the first president of the United States?",
    options: ["Thomas Jefferson", "Abraham Lincoln", "George Washington", "John Adams"],
    answer: "George Washington"
  },
  {
    id: 47,
    question: "What is the national flower of Japan?",
    options: ["Rose", "Lotus", "Cherry Blossom", "Tulip"],
    answer: "Cherry Blossom"
  },
  {
    id: 48,
    question: "Which ocean lies between Africa and Australia?",
    options: ["Atlantic Ocean", "Indian Ocean", "Pacific Ocean", "Arctic Ocean"],
    answer: "Indian Ocean"
  },
  {
    id: 49,
    question: "What is the chemical symbol for Silver?",
    options: ["Si", "Ag", "S", "Sr"],
    answer: "Ag"
  },
  {
    id: 50,
    question: "How many teeth does an adult human typically have?",
    options: ["28", "30", "32", "34"],
    answer: "32"
  },
  {
    id: 51,
    question: "What is the capital of Australia?",
    options: ["Sydney", "Melbourne", "Canberra", "Brisbane"],
    answer: "Canberra"
  },
  {
    id: 52,
    question: "What is the chemical symbol for Sodium?",
    options: ["Na", "So", "Sd", "N"],
    answer: "Na"
  },
  {
    id: 53,
    question: "Which planet in our solar system has the most moons?",
    options: ["Jupiter", "Saturn", "Uranus", "Neptune"],
    answer: "Saturn"
  },
  {
    id: 54,
    question: "Who wrote the novel 'Moby-Dick'?",
    options: ["Nathaniel Hawthorne", "Herman Melville", "Mark Twain", "Edgar Allan Poe"],
    answer: "Herman Melville"
  },
  {
    id: 55,
    question: "What is the currency of Japan?",
    options: ["Yuan", "Won", "Yen", "Ringgit"],
    answer: "Yen"
  },
  {
    id: 56,
    question: "Which blood type is known as the universal donor?",
    options: ["A positive", "B positive", "AB positive", "O negative"],
    answer: "O negative"
  },
  {
    id: 57,
    question: "What is the largest country in the world by land area?",
    options: ["Canada", "China", "United States", "Russia"],
    answer: "Russia"
  },
  {
    id: 58,
    question: "In what year did the Berlin Wall fall?",
    options: ["1987", "1989", "1991", "1993"],
    answer: "1989"
  },
  {
    id: 59,
    question: "What is the main component of the sun?",
    options: ["Helium", "Hydrogen", "Oxygen", "Carbon"],
    answer: "Hydrogen"
  },
  {
    id: 60,
    question: "Which artist cut off a portion of his own ear?",
    options: ["Claude Monet", "Vincent van Gogh", "Salvador Dalí", "Pablo Picasso"],
    answer: "Vincent van Gogh"
  },
  {
    id: 61,
    question: "What is the tallest mountain in the world above sea level?",
    options: ["K2", "Kangchenjunga", "Mount Everest", "Lhotse"],
    answer: "Mount Everest"
  },
  {
    id: 62,
    question: "Which programming language was created by Guido van Rossum?",
    options: ["Java", "Python", "C++", "Ruby"],
    answer: "Python"
  },
  {
    id: 63,
    question: "What is the chemical symbol for Potassium?",
    options: ["P", "Pt", "K", "Po"],
    answer: "K"
  },
  {
    id: 64,
    question: "How many bones are in the human face?",
    options: ["10", "14", "18", "22"],
    answer: "14"
  },
  {
    id: 65,
    question: "Which Shakespearean play features the character Hamlet?",
    options: ["Macbeth", "Hamlet", "Othello", "King Lear"],
    answer: "Hamlet"
  },
  {
    id: 66,
    question: "What is the smallest planet in our solar system?",
    options: ["Mars", "Venus", "Mercury", "Pluto"],
    answer: "Mercury"
  },
  {
    id: 67,
    question: "What is the national animal of India?",
    options: ["Lion", "Elephant", "Royal Bengal Tiger", "Indian Peacock"],
    answer: "Royal Bengal Tiger"
  },
  {
    id: 68,
    question: "Which element is diamond an allotrope of?",
    options: ["Carbon", "Silicon", "Boron", "Nitrogen"],
    answer: "Carbon"
  },
  {
    id: 69,
    question: "What year did World War I begin?",
    options: ["1912", "1914", "1916", "1918"],
    answer: "1914"
  },
  {
    id: 70,
    question: "What is the primary gas found in the atmosphere of Mars?",
    options: ["Oxygen", "Nitrogen", "Carbon Dioxide", "Hydrogen"],
    answer: "Carbon Dioxide"
  },
  {
    id: 71,
    question: "Who developed the theory of general relativity?",
    options: ["Isaac Newton", "Albert Einstein", "Niels Bohr", "Max Planck"],
    answer: "Albert Einstein"
  },
  {
    id: 72,
    question: "What is the chemical symbol for Copper?",
    options: ["Co", "Cu", "C", "Cp"],
    answer: "Cu"
  },
  {
    id: 73,
    question: "Which instrument is used to measure atmospheric pressure?",
    options: ["Thermometer", "Barometer", "Hygrometer", "Anemometer"],
    answer: "Barometer"
  },
  {
    id: 74,
    question: "What is the capital city of Egypt?",
    options: ["Alexandria", "Cairo", "Giza", "Luxor"],
    answer: "Cairo"
  },
  {
    id: 75,
    question: "Which ocean is the second largest by surface area?",
    options: ["Pacific Ocean", "Indian Ocean", "Atlantic Ocean", "Arctic Ocean"],
    answer: "Atlantic Ocean"
  },
  {
    id: 76,
    question: "What is the value of the mathematical constant e to two decimal places?",
    options: ["2.14", "2.72", "3.14", "3.67"],
    answer: "2.72"
  },
  {
    id: 77,
    question: "Which vitamin is also known as ascorbic acid?",
    options: ["Vitamin A", "Vitamin B", "Vitamin C", "Vitamin D"],
    answer: "Vitamin C"
  },
  {
    id: 78,
    question: "Who is credited with inventing the World Wide Web?",
    options: ["Bill Gates", "Steve Jobs", "Tim Berners-Lee", "Mark Zuckerberg"],
    answer: "Tim Berners-Lee"
  },
  {
    id: 79,
    question: "What is the hardest mineral on the Mohs scale?",
    options: ["Quartz", "Topaz", "Corundum", "Diamond"],
    answer: "Diamond"
  },
  {
    id: 80,
    question: "In what country is the ancient city of Petra located?",
    options: ["Egypt", "Jordan", "Greece", "Turkey"],
    answer: "Jordan"
  },
  {
    id: 81,
    question: "What is the chemical symbol for Lead?",
    options: ["Pb", "Ld", "Le", "Pd"],
    answer: "Pb"
  },
  {
    id: 82,
    question: "Which layer of Earth's atmosphere contains the ozone layer?",
    options: ["Troposphere", "Stratosphere", "Mesosphere", "Thermosphere"],
    answer: "Stratosphere"
  },
  {
    id: 83,
    question: "Who wrote 'Pride and Prejudice'?",
    options: ["Charlotte Brontë", "Jane Austen", "Emily Brontë", "George Eliot"],
    answer: "Jane Austen"
  },
  {
    id: 84,
    question: "What is the capital of Brazil?",
    options: ["Rio de Janeiro", "São Paulo", "Brasília", "Salvador"],
    answer: "Brasília"
  },
  {
    id: 85,
    question: "Which gas is responsible for the characteristic smell after a thunderstorm?",
    options: ["Ozone", "Methane", "Carbon Monoxide", "Helium"],
    answer: "Ozone"
  },
  {
    id: 86,
    question: "What is the speed of sound in dry air at 20°C approximately?",
    options: ["243 m/s", "343 m/s", "443 m/s", "543 m/s"],
    answer: "343 m/s"
  },
  {
    id: 87,
    question: "Which planet rotates on its side?",
    options: ["Jupiter", "Saturn", "Uranus", "Neptune"],
    answer: "Uranus"
  },
  {
    id: 88,
    question: "What is the main metal used to manufacture bronze?",
    options: ["Iron", "Copper", "Zinc", "Nickel"],
    answer: "Copper"
  },
  {
    id: 89,
    question: "Who painted 'The Last Supper'?",
    options: ["Michelangelo", "Raphael", "Leonardo da Vinci", "Donatello"],
    answer: "Leonardo da Vinci"
  },
  {
    id: 90,
    question: "What is the largest internal organ in the human body?",
    options: ["Heart", "Liver", "Kidney", "Lungs"],
    answer: "Liver"
  },
  {
    id: 91,
    question: "Which country shares the longest land border with the United States?",
    options: ["Mexico", "Russia", "Canada", "Cuba"],
    answer: "Canada"
  },
  {
    id: 92,
    question: "What is the atomic number of Carbon?",
    options: ["5", "6", "7", "8"],
    answer: "6"
  },
  {
    id: 93,
    question: "Who wrote 'The Odyssey'?",
    options: ["Sophocles", "Homer", "Plato", "Aristotle"],
    answer: "Homer"
  },
  {
    id: 94,
    question: "What is the capital of South Korea?",
    options: ["Beijing", "Tokyo", "Seoul", "Pyongyang"],
    answer: "Seoul"
  },
  {
    id: 95,
    question: "Which blood cells are responsible for carrying oxygen throughout the body?",
    options: ["White blood cells", "Red blood cells", "Platelets", "Plasma"],
    answer: "Red blood cells"
  },
  {
    id: 96,
    question: "What is the chemical symbol for Silver?",
    options: ["Si", "Ag", "Sr", "Sn"],
    answer: "Ag"
  },
  {
    id: 97,
    question: "Which famous scientist proposed the three laws of motion?",
    options: ["Galileo Galilei", "Albert Einstein", "Isaac Newton", "Nikola Tesla"],
    answer: "Isaac Newton"
  },
  {
    id: 98,
    question: "What is the largest island in the world?",
    options: ["Madagascar", "Borneo", "Greenland", "New Guinea"],
    answer: "Greenland"
  },
  {
    id: 99,
    question: "Which chemical element has the highest melting point?",
    options: ["Iron", "Tungsten", "Platinum", "Titanium"],
    answer: "Tungsten"
  },
  {
    id: 100,
    question: "How many degrees are in a full circle?",
    options: ["180", "270", "360", "450"],
    answer: "360"
  },
  {
    id: 101,
    question: "Which country has the most natural lakes?",
    options: ["United States", "Canada", "Russia", "Brazil"],
    answer: "Canada"
  },
  {
    id: 102,
    question: "What is the official currency of Mexico?",
    options: ["Peso", "Real", "Dollar", "Sol"],
    answer: "Peso"
  },
  {
    id: 103,
    question: "Which gas makes up approximately 78% of Earth's atmosphere?",
    options: ["Oxygen", "Carbon Dioxide", "Nitrogen", "Argon"],
    answer: "Nitrogen"
  },
  {
    id: 104,
    question: "Who wrote the famous novel '1984'?",
    options: ["Aldous Huxley", "George Orwell", "Ray Bradbury", "J.D. Salinger"],
    answer: "George Orwell"
  },
  {
    id: 105,
    question: "What is the capital city of Argentina?",
    options: ["Santiago", "Buenos Aires", "Lima", "Bogotá"],
    answer: "Buenos Aires"
  },
  {
    id: 106,
    question: "Which musical instrument has pedals and a large frame with strings?",
    options: ["Cello", "Harpsichord", "Harp", "Accordion"],
    answer: "Harp"
  },
  {
    id: 107,
    question: "What is the primary ingredient in traditional hummus?",
    options: ["Lentils", "Chickpeas", "Black beans", "Peas"],
    answer: "Chickpeas"
  },
  {
    id: 108,
    question: "In what year did the Apollo 11 mission land humans on the Moon?",
    options: ["1967", "1969", "1971", "1973"],
    answer: "1969"
  },
  {
    id: 109,
    question: "What is the chemical element with the symbol 'Sn'?",
    options: ["Sodium", "Tin", "Antimony", "Sulfur"],
    answer: "Tin"
  },
  {
    id: 110,
    question: "Which continent is the least populated?",
    options: ["Australia", "Antarctica", "Europe", "South America"],
    answer: "Antarctica"
  },
  {
    id: 111,
    question: "Who discovered penicillin in 1928?",
    options: ["Louis Pasteur", "Alexander Fleming", "Edward Jenner", "Robert Koch"],
    answer: "Alexander Fleming"
  },
  {
    id: 112,
    question: "What is the national sport of Canada?",
    options: ["Ice Hockey and Lacrosse", "Baseball", "Cricket", "Basketball"],
    answer: "Ice Hockey and Lacrosse"
  },
  {
    id: 113,
    question: "Which desert is the largest hot desert in the world?",
    options: ["Gobi Desert", "Kalahari Desert", "Sahara Desert", "Mojave Desert"],
    answer: "Sahara Desert"
  },
  {
    id: 114,
    question: "What is the capital of Spain?",
    options: ["Barcelona", "Valencia", "Madrid", "Seville"],
    answer: "Madrid"
  },
  {
    id: 115,
    question: "How many strings does a standard acoustic guitar have?",
    options: ["4", "5", "6", "8"],
    answer: "6"
  },
  {
    id: 116,
    question: "Which planet is famous for its prominent ring system visible from Earth?",
    options: ["Jupiter", "Saturn", "Uranus", "Neptune"],
    answer: "Saturn"
  },
  {
    id: 117,
    question: "Who painted the ceiling of the Sistine Chapel?",
    options: ["Leonardo da Vinci", "Raphael", "Michelangelo", "Donatello"],
    answer: "Michelangelo"
  },
  {
    id: 118,
    question: "What is the main language spoken in Brazil?",
    options: ["Spanish", "Portuguese", "French", "English"],
    answer: "Portuguese"
  },
  {
    id: 119,
    question: "What is the smallest bone in the human body?",
    options: ["Stapes", "Incus", "Malleus", "Femur"],
    answer: "Stapes"
  },
  {
    id: 120,
    question: "Which city is known as the 'Eternal City'?",
    options: ["Athens", "Paris", "Rome", "Cairo"],
    answer: "Rome"
  },
  {
    id: 121,
    question: "What is the chemical formula for table salt?",
    options: ["NaCl", "KCl", "NaOH", "HCl"],
    answer: "NaCl"
  },
  {
    id: 122,
    question: "Who wrote the play 'Macbeth'?",
    options: ["Christopher Marlowe", "William Shakespeare", "George Bernard Shaw", "Oscar Wilde"],
    answer: "William Shakespeare"
  },
  {
    id: 123,
    question: "Which country is known as the Land of the Rising Sun?",
    options: ["China", "South Korea", "Japan", "Thailand"],
    answer: "Japan"
  },
  {
    id: 124,
    question: "What is the tallest animal in the world?",
    options: ["Elephant", "Giraffe", "Hippopotamus", "Rhinoceros"],
    answer: "Giraffe"
  },
  {
    id: 125,
    question: "Which scientific instrument is used to measure earthquakes?",
    options: ["Barometer", "Seismograph", "Anemometer", "Hydrometer"],
    answer: "Seismograph"
  },
  {
    id: 126,
    question: "What is the capital of New Zealand?",
    options: ["Auckland", "Christchurch", "Wellington", "Hamilton"],
    answer: "Wellington"
  },
  {
    id: 127,
    question: "Which chemical element has the atomic number 79?",
    options: ["Silver", "Gold", "Platinum", "Copper"],
    answer: "Gold"
  },
  {
    id: 128,
    question: "Who directed the movie 'Jurassic Park' (1993)?",
    options: ["James Cameron", "Steven Spielberg", "Ridley Scott", "George Lucas"],
    answer: "Steven Spielberg"
  },
  {
    id: 129,
    question: "What is the primary ingredient of glass?",
    options: ["Clay", "Silica (Sand)", "Limestone", "Plastic"],
    answer: "Silica (Sand)"
  },
  {
    id: 130,
    question: "Which ocean is the largest by volume and surface area?",
    options: ["Atlantic Ocean", "Indian Ocean", "Arctic Ocean", "Pacific Ocean"],
    answer: "Pacific Ocean"
  },
  {
    id: 131,
    question: "What is the capital of Germany?",
    options: ["Munich", "Frankfurt", "Berlin", "Hamburg"],
    answer: "Berlin"
  },
  {
    id: 132,
    question: "How many players are on the ice for one team in a standard ice hockey game?",
    options: ["5", "6", "7", "8"],
    answer: "6"
  },
  {
    id: 133,
    question: "Which vitamin is essential for blood clotting?",
    options: ["Vitamin A", "Vitamin C", "Vitamin D", "Vitamin K"],
    answer: "Vitamin K"
  },
  {
    id: 134,
    question: "Who was the second President of the United States?",
    options: ["Thomas Jefferson", "John Adams", "James Madison", "Benjamin Franklin"],
    answer: "John Adams"
  },
  {
    id: 135,
    question: "What is the capital of South Africa (administrative)?",
    options: ["Cape Town", "Johannesburg", "Pretoria", "Durban"],
    answer: "Pretoria"
  },
  {
    id: 136,
    question: "Which gas is most abundant in the sun?",
    options: ["Helium", "Hydrogen", "Oxygen", "Neon"],
    answer: "Hydrogen"
  },
  {
    id: 137,
    question: "What is the main currency used in European Union countries that adopted the euro?",
    options: ["Euro", "Franc", "Mark", "Lira"],
    answer: "Euro"
  },
  {
    id: 138,
    question: "Who wrote 'The Adventures of Tom Sawyer'?",
    options: ["Herman Melville", "Mark Twain", "Charles Dickens", "Jack London"],
    answer: "Mark Twain"
  },
  {
    id: 139,
    question: "What is the hardest metal on Earth?",
    options: ["Iron", "Chromium", "Tungsten", "Titanium"],
    answer: "Chromium"
  },
  {
    id: 140,
    question: "Which mountain range separates Europe from Asia?",
    options: ["Alps", "Andes", "Himalayas", "Ural Mountains"],
    answer: "Ural Mountains"
  },
  {
    id: 141,
    question: "What is the chemical symbol for Helium?",
    options: ["H", "He", "Hm", "hl"],
    answer: "He"
  },
  {
    id: 142,
    question: "Who painted 'The Creation of Adam'?",
    options: ["Leonardo da Vinci", "Michelangelo", "Raphael", "Caravaggio"],
    answer: "Michelangelo"
  },
  {
    id: 143,
    question: "What is the freezing point of water in Celsius?",
    options: ["-1°C", "0°C", "1°C", "10°C"],
    answer: "0°C"
  },
  {
    id: 144,
    question: "Which planet is known as the Morning Star or Evening Star?",
    options: ["Mars", "Venus", "Mercury", "Jupiter"],
    answer: "Venus"
  },
  {
    id: 145,
    question: "What is the capital city of India?",
    options: ["Mumbai", "Kolkata", "New Delhi", "Bengaluru"],
    answer: "New Delhi"
  },
  {
    id: 146,
    question: "Which writer created the fictional detective Sherlock Holmes?",
    options: ["Agatha Christie", "Arthur Conan Doyle", "Edgar Allan Poe", "J.R.R. Tolkien"],
    answer: "Arthur Conan Doyle"
  },
  {
    id: 147,
    question: "What is the primary function of white blood cells?",
    options: ["Carry oxygen", "Fight infections", "Clot blood", "Digest nutrients"],
    answer: "Fight infections"
  },
  {
    id: 148,
    question: "Which country is famously shaped like a boot?",
    options: ["Greece", "Spain", "Italy", "France"],
    answer: "Italy"
  },
  {
    id: 149,
    question: "What is the largest bone in the human body?",
    options: ["Humerus", "Tibia", "Femur", "Fibula"],
    answer: "Femur"
  },
  {
    id: 150,
    question: "In what year did the First World War end?",
    options: ["1916", "1917", "1918", "1919"],
    answer: "1918"
  },
  {
    id: 151,
    question: "Which planet is the hottest in our solar system?",
    options: ["Mercury", "Venus", "Mars", "Jupiter"],
    answer: "Venus"
  },
  {
    id: 152,
    question: "What is the national flower of India?",
    options: ["Lotus", "Rose", "Sunflower", "Jasmine"],
    answer: "Lotus"
  },
  {
    id: 153,
    question: "Who wrote the famous epic poem 'The Divine Comedy'?",
    options: ["Homer", "Dante Alighieri", "Virgil", "Geoffrey Chaucer"],
    answer: "Dante Alighieri"
  },
  {
    id: 154,
    question: "What is the chemical symbol for Mercury?",
    options: ["Me", "Mc", "Hg", "My"],
    answer: "Hg"
  },
  {
    id: 155,
    question: "Which country won the FIFA World Cup in 2022?",
    options: ["Brazil", "France", "Argentina", "Germany"],
    answer: "Argentina"
  },
  {
    id: 156,
    question: "What is the main component of natural gas?",
    options: ["Methane", "Ethane", "Propane", "Butane"],
    answer: "Methane"
  },
  {
    id: 157,
    question: "Who painted 'The Persistence of Memory' featuring melting clocks?",
    options: ["Pablo Picasso", "Salvador Dalí", "Claude Monet", "Henri Matisse"],
    answer: "Salvador Dalí"
  },
  {
    id: 158,
    question: "What is the capital city of Kenya?",
    options: ["Nairobi", "Mombasa", "Kisumu", "Nakuru"],
    answer: "Nairobi"
  },
  {
    id: 159,
    question: "Which metal has the highest electrical conductivity?",
    options: ["Gold", "Copper", "Silver", "Aluminum"],
    answer: "Silver"
  },
  {
    id: 160,
    question: "How many players are on the field for a single baseball team during play?",
    options: ["7", "9", "11", "12"],
    answer: "9"
  },
  {
    id: 161,
    question: "What is the official currency of Thailand?",
    options: ["Ringgit", "Baht", "Dong", "Peso"],
    answer: "Baht"
  },
  {
    id: 162,
    question: "Who was the first woman to fly solo across the Atlantic Ocean?",
    options: ["Amelia Earhart", "Sally Ride", "Harriet Quimby", "Valentina Tereshkova"],
    answer: "Amelia Earhart"
  },
  {
    id: 163,
    question: "What is the smallest independent country in the world by land area?",
    options: ["Monaco", "Liechtenstein", "Vatican City", "San Marino"],
    answer: "Vatican City"
  },
  {
    id: 164,
    question: "Which vitamin is also known as retinol?",
    options: ["Vitamin A", "Vitamin B", "Vitamin C", "Vitamin E"],
    answer: "Vitamin A"
  },
  {
    id: 165,
    question: "What is the capital of Turkey?",
    options: ["Istanbul", "Ankara", "Izmir", "Antalya"],
    answer: "Ankara"
  },
  {
    id: 166,
    question: "Which metal is liquid at standard room temperature and pressure?",
    options: ["Gallium", "Mercury", "Lead", "Tin"],
    answer: "Mercury"
  },
  {
    id: 167,
    question: "Who wrote the Gothic horror novel 'Frankenstein'?",
    options: ["Bram Stoker", "Mary Shelley", "H.G. Wells", "Edgar Allan Poe"],
    answer: "Mary Shelley"
  },
  {
    id: 168,
    question: "What is the line of latitude that divides the Earth into the Northern and Southern Hemispheres?",
    options: ["Tropic of Cancer", "Equator", "Prime Meridian", "Tropic of Capricorn"],
    answer: "Equator"
  },
  {
    id: 169,
    question: "Which noble gas is commonly used in filling fluorescent lights?",
    options: ["Neon", "Argon", "Helium", "Xenon"],
    answer: "Argon"
  },
  {
    id: 170,
    question: "What is the chemical symbol for Zinc?",
    options: ["Zi", "Zn", "Zc", "Z"],
    answer: "Zn"
  },
  {
    id: 171,
    question: "Who was the ancient Greek god of the sea?",
    options: ["Zeus", "Hades", "Poseidon", "Apollo"],
    answer: "Poseidon"
  },
  {
    id: 172,
    question: "Which large desert spans parts of northern China and southern Mongolia?",
    options: ["Gobi Desert", "Arabian Desert", "Thar Desert", "Karakum Desert"],
    answer: "Gobi Desert"
  },
  {
    id: 173,
    question: "Which programming language was developed by James Gosling at Sun Microsystems?",
    options: ["C++", "Java", "Python", "PHP"],
    answer: "Java"
  },
  {
    id: 174,
    question: "What is the capital of Greece?",
    options: ["Sparta", "Athens", "Thessaloniki", "Corinth"],
    answer: "Athens"
  },
  {
    id: 175,
    question: "Which animal is commonly referred to as the 'Ship of the Desert'?",
    options: ["Horse", "Camel", "Elephant", "Donkey"],
    answer: "Camel"
  },
  {
    id: 176,
    question: "What is the square root of 225?",
    options: ["13", "14", "15", "16"],
    answer: "15"
  },
  {
    id: 177,
    question: "Who discovered X-rays in 1895?",
    options: ["Marie Curie", "Wilhelm Conrad Röntgen", "Thomas Edison", "Nikola Tesla"],
    answer: "Wilhelm Conrad Röntgen"
  },
  {
    id: 178,
    question: "What is the primary language spoken in Argentina?",
    options: ["Portuguese", "Spanish", "Italian", "English"],
    answer: "Spanish"
  },
  {
    id: 179,
    question: "Which planet in our solar system features the massive storm known as the Great Red Spot?",
    options: ["Mars", "Saturn", "Jupiter", "Neptune"],
    answer: "Jupiter"
  },
  {
    id: 180,
    question: "What is the capital of Sweden?",
    options: ["Oslo", "Copenhagen", "Stockholm", "Helsinki"],
    answer: "Stockholm"
  },
  {
    id: 181,
    question: "Who wrote the 1862 historical novel 'Les Misérables'?",
    options: ["Alexandre Dumas", "Victor Hugo", "Jules Verne", "Voltaire"],
    answer: "Victor Hugo"
  },
  {
    id: 182,
    question: "What is the chemical symbol for Nitrogen?",
    options: ["N", "Ni", "Na", "Ne"],
    answer: "N"
  },
  {
    id: 183,
    question: "Which organ in the human body produces insulin?",
    options: ["Liver", "Pancreas", "Kidneys", "Spleen"],
    answer: "Pancreas"
  },
  {
    id: 184,
    question: "What is the capital of Vietnam?",
    options: ["Hanoi", "Ho Chi Minh City", "Da Nang", "Hue"],
    answer: "Hanoi"
  },
  {
    id: 185,
    question: "Which inland body of water has the lowest land elevation on Earth?",
    options: ["Caspian Sea", "Red Sea", "Dead Sea", "Black Sea"],
    answer: "Dead Sea"
  },
  {
    id: 186,
    question: "Who is credited with inventing the first practical telephone?",
    options: ["Thomas Edison", "Alexander Graham Bell", "Nikola Tesla", "Guglielmo Marconi"],
    answer: "Alexander Graham Bell"
  },
  {
    id: 187,
    question: "What is the main chemical compound that gives strength to human bones and teeth?",
    options: ["Calcium phosphate", "Sodium chloride", "Iron oxide", "Potassium carbonate"],
    answer: "Calcium phosphate"
  },
  {
    id: 188,
    question: "Which African nation contains the highest number of ancient pyramids in the world?",
    options: ["Egypt", "Sudan", "Libya", "Algeria"],
    answer: "Sudan"
  },
  {
    id: 189,
    question: "What is the de facto capital city of Switzerland?",
    options: ["Zurich", "Geneva", "Bern", "Basel"],
    answer: "Bern"
  },
  {
    id: 190,
    question: "Which subatomic particle carries a negative electric charge?",
    options: ["Proton", "Neutron", "Electron", "Positron"],
    answer: "Electron"
  },
  {
    id: 191,
    question: "Who painted the famous Renaissance fresco 'The School of Athens'?",
    options: ["Raphael", "Michelangelo", "Leonardo da Vinci", "Botticelli"],
    answer: "Raphael"
  },
  {
    id: 192,
    question: "What is the highest uninterrupted waterfall in the world?",
    options: ["Niagara Falls", "Victoria Falls", "Angel Falls", "Iguazu Falls"],
    answer: "Angel Falls"
  },
  {
    id: 193,
    question: "Which gas makes up approximately 21% of Earth's atmosphere?",
    options: ["Nitrogen", "Oxygen", "Carbon Dioxide", "Argon"],
    answer: "Oxygen"
  },
  {
    id: 194,
    question: "What is the capital of Portugal?",
    options: ["Porto", "Lisbon", "Coimbra", "Faro"],
    answer: "Lisbon"
  },
  {
    id: 195,
    question: "Which author wrote the high fantasy epic 'The Lord of the Rings'?",
    options: ["C.S. Lewis", "J.R.R. Tolkien", "George R.R. Martin", "J.K. Rowling"],
    answer: "J.R.R. Tolkien"
  },
  {
    id: 196,
    question: "What is the boiling point of pure water at standard atmospheric pressure in Fahrenheit?",
    options: ["100°F", "212°F", "250°F", "320°F"],
    answer: "212°F"
  },
  {
    id: 197,
    question: "Which ancient wonder of the ancient world stood on the island of Pharos in Egypt?",
    options: ["Hanging Gardens of Babylon", "Colossus of Rhodes", "Lighthouse of Alexandria", "Great Pyramid of Giza"],
    answer: "Lighthouse of Alexandria"
  },
  {
    id: 198,
    question: "What is the atomic number of Zinc?",
    options: ["28", "30", "32", "34"],
    answer: "30"
  },
  {
    id: 199,
    question: "Who was the first human being to step foot on the Moon?",
    options: ["Buzz Aldrin", "Yuri Gagarin", "Neil Armstrong", "Michael Collins"],
    answer: "Neil Armstrong"
  },
  {
    id: 200,
    question: "What is the official currency of the People's Republic of China?",
    options: ["Yen", "Won", "Yuan", "Ringgit"],
    answer: "Yuan"
  },
  {
    id: 201,
    question: "Which organelle is responsible for protein synthesis in the cell?",
    options: ["Golgi apparatus", "Ribosome", "Lysosome", "Centriole"],
    answer: "Ribosome"
  },
  {
    id: 202,
    question: "What is the primary pigment used by plants in photosynthesis?",
    options: ["Carotenoid", "Chlorophyll", "Xanthophyll", "Anthocyanin"],
    answer: "Chlorophyll"
  },
  {
    id: 203,
    question: "Which blood vessels carry oxygenated blood away from the heart?",
    options: ["Veins", "Capillaries", "Arteries", "Vena cava"],
    answer: "Arteries"
  },
  {
    id: 204,
    question: "What is the genetic material found in most living organisms?",
    options: ["RNA", "DNA", "Protein", "Lipid"],
    answer: "DNA"
  },
  {
    id: 205,
    question: "Which process do plant cells use to convert sunlight into chemical energy?",
    options: ["Respiration", "Transpiration", "Photosynthesis", "Fermentation"],
    answer: "Photosynthesis"
  },
  {
    id: 206,
    question: "What is the functional unit of the human kidney?",
    options: ["Neuron", "Nephron", "Alveolus", "Axon"],
    answer: "Nephron"
  },
  {
    id: 207,
    question: "Which phase of cell division involves the replication of DNA?",
    options: ["Prophase", "Interphase", "Anaphase", "Telophase"],
    answer: "Interphase"
  },
  {
    id: 208,
    question: "What type of symbiotic relationship benefits both organisms involved?",
    options: ["Parasitism", "Commensalism", "Mutualism", "Competition"],
    answer: "Mutualism"
  },
  {
    id: 209,
    question: "Which human organ system is primarily responsible for defending against pathogens?",
    options: ["Circulatory system", "Immune system", "Digestive system", "Endocrine system"],
    answer: "Immune system"
  },
  {
    id: 210,
    question: "What is the term for a permanent change in the nucleotide sequence of DNA?",
    options: ["Mutation", "Transcription", "Translation", "Replication"],
    answer: "Mutation"
  },
  {
    id: 211,
    question: "Which gas is released during cellular respiration?",
    options: ["Oxygen", "Carbon dioxide", "Nitrogen", "Hydrogen"],
    answer: "Carbon dioxide"
  },
  {
    id: 212,
    question: "What plant tissue is responsible for transporting water and dissolved minerals from roots to stems and leaves?",
    options: ["Phloem", "Xylem", "Cortex", "Cambium"],
    answer: "Xylem"
  },
  {
    id: 213,
    question: "Which scientist is known as the father of modern genetics for his experiments with pea plants?",
    options: ["Charles Darwin", "Gregor Mendel", "Louis Pasteur", "James Watson"],
    answer: "Gregor Mendel"
  },
  {
    id: 214,
    question: "What is the powerhouse of the eukaryotic cell?",
    options: ["Nucleus", "Ribosome", "Mitochondria", "Endoplasmic reticulum"],
    answer: "Mitochondria"
  },
  {
    id: 215,
    question: "Which vitamin is produced in the human skin under sunlight exposure?",
    options: ["Vitamin A", "Vitamin C", "Vitamin D", "Vitamin K"],
    answer: "Vitamin D"
  },
  {
    id: 216,
    question: "What is the liquid portion of blood called?",
    options: ["Plasma", "Serum", "Platelets", "Lymph"],
    answer: "Plasma"
  },
  {
    id: 217,
    question: "Which structural feature is present in plant cells but absent in animal cells?",
    options: ["Cell membrane", "Cell wall", "Mitochondria", "Ribosome"],
    answer: "Cell wall"
  },
  {
    id: 218,
    question: "What name is given to animals that eat both plants and meat?",
    options: ["Herbivores", "Carnivores", "Omnivores", "Detritivores"],
    answer: "Omnivores"
  },
  {
    id: 219,
    question: "Which part of the human brain controls balance and coordination?",
    options: ["Cerebrum", "Cerebellum", "Medulla oblongata", "Hypothalamus"],
    answer: "Cerebellum"
  },
  {
    id: 220,
    question: "What type of cellular division results in the formation of gametes (sperm and egg cells)?",
    options: ["Mitosis", "Meiosis", "Binary fission", "Budding"],
    answer: "Meiosis"
  },
  {
    id: 221,
    question: "Which nitrogenous base pairs with Adenine in a DNA molecule?",
    options: ["Guanine", "Cytosine", "Thymine", "Uracil"],
    answer: "Thymine"
  },
  {
    id: 222,
    question: "What is the primary function of white blood cells?",
    options: ["Transport oxygen", "Clot blood", "Fight infections", "Digest food"],
    answer: "Fight infections"
  },
  {
    id: 223,
    question: "Which hormone regulates blood sugar levels by facilitating glucose uptake in cells?",
    options: ["Adrenaline", "Insulin", "Thyroxine", "Estrogen"],
    answer: "Insulin"
  },
  {
    id: 224,
    question: "What plant tissue is responsible for transporting organic nutrients (food) throughout the plant?",
    options: ["Xylem", "Phloem", "Pith", "Epidermis"],
    answer: "Phloem"
  },
  {
    id: 225,
    question: "Which evolutionary scientist proposed the theory of natural selection alongside Charles Darwin?",
    options: ["Alfred Russel Wallace", "Jean-Baptiste Lamarck", "Thomas Malthus", "Charles Lyell"],
    answer: "Alfred Russel Wallace"
  },
  {
    id: 226,
    question: "What is the name of the tiny air sacs in the lungs where gas exchange occurs?",
    options: ["Bronchi", "Trachea", "Alveoli", "Larynx"],
    answer: "Alveoli"
  },
  {
    id: 227,
    question: "Which class of biomolecules do enzymes belong to?",
    options: ["Carbohydrates", "Lipids", "Proteins", "Nucleic acids"],
    answer: "Proteins"
  },
  {
    id: 228,
    question: "What is the study of interactions between organisms and their environment called?",
    options: ["Taxonomy", "Ecology", "Anatomy", "Genetics"],
    answer: "Ecology"
  },
  {
    id: 229,
    question: "Which human blood type is considered the universal recipient?",
    options: ["Type O negative", "Type A positive", "Type AB positive", "Type B negative"],
    answer: "Type AB positive"
  },
  {
    id: 230,
    question: "What is the process by which water moves across a semipermeable membrane?",
    options: ["Active transport", "Osmosis", "Diffusion", "Phagocytosis"],
    answer: "Osmosis"
  },
  {
    id: 231,
    question: "Which organelle contains digestive enzymes to break down waste materials in the cell?",
    options: ["Ribosome", "Lysosome", "Golgi body", "Chloroplast"],
    answer: "Lysosome"
  },
  {
    id: 232,
    question: "What is the main structural component of plant cell walls?",
    options: ["Starch", "Glycogen", "Cellulose", "Chitin"],
    answer: "Cellulose"
  },
  {
    id: 233,
    question: "Which gland is often referred to as the 'master gland' of the endocrine system?",
    options: ["Thyroid gland", "Adrenal gland", "Pituitary gland", "Pancreas"],
    answer: "Pituitary gland"
  },
  {
    id: 234,
    question: "What term describes organisms that can make their own food using light or chemical energy?",
    options: ["Heterotrophs", "Autotrophs", "Decomposers", "Saprophytes"],
    answer: "Autotrophs"
  },
  {
    id: 235,
    question: "Which organic molecule serves as the primary short-term energy currency of cells?",
    options: ["DNA", "ATP", "Glucose", "RNA"],
    answer: "ATP"
  },
  {
    id: 236,
    question: "What is the double-layered membrane that surrounds the nucleus called?",
    options: ["Cell membrane", "Nuclear envelope", "Endoplasmic reticulum", "Capsule"],
    answer: "Nuclear envelope"
  },
  {
    id: 237,
    question: "Which division of the peripheral nervous system controls voluntary skeletal muscle movements?",
    options: ["Autonomic nervous system", "Sympathetic nervous system", "Somatic nervous system", "Parasympathetic nervous system"],
    answer: "Somatic nervous system"
  },
  {
    id: 238,
    question: "What is the term for the process where plants lose water vapor through pores in their leaves?",
    options: ["Respiration", "Transpiration", "Evaporation", "Guttation"],
    answer: "Transpiration"
  },
  {
    id: 239,
    question: "Which animal phylum includes insects, arachnids, and crustaceans?",
    options: ["Mollusca", "Annelida", "Arthropoda", "Chordata"],
    answer: "Arthropoda"
  },
  {
    id: 240,
    question: "What is the primary function of hemoglobin in red blood cells?",
    options: ["Fight infection", "Transport oxygen", "Clot blood", "Digest proteins"],
    answer: "Transport oxygen"
  },
  {
    id: 241,
    question: "Which cellular process occurs in the cytoplasm and breaks down glucose without oxygen?",
    options: ["Krebs cycle", "Glycolysis", "Electron transport chain", "Oxidative phosphorylation"],
    answer: "Glycolysis"
  },
  {
    id: 242,
    question: "What is the name of the protective protein coat surrounding a virus?",
    options: ["Capsid", "Cell wall", "Envelope", "Membrane"],
    answer: "Capsid"
  },
  {
    id: 243,
    question: "Which specialized structures on plant leaves regulate gas exchange and water loss?",
    options: ["Stomata", "Lenticels", "Root hairs", "Cuticles"],
    answer: "Stomata"
  },
  {
    id: 244,
    question: "What is the term for an organism's genetic makeup, as distinguished from its physical appearance?",
    options: ["Phenotype", "Genotype", "Karyotype", "Genome"],
    answer: "Genotype"
  },
  {
    id: 245,
    question: "Which organ in the human body detoxifies chemicals and metabolizes drugs?",
    options: ["Kidney", "Liver", "Pancreas", "Spleen"],
    answer: "Liver"
  },
  {
    id: 246,
    question: "What type of skeletal system do insects possess on the outside of their bodies?",
    options: ["Endoskeleton", "Exoskeleton", "Hydrostatic skeleton", "Cartilaginous skeleton"],
    answer: "Exoskeleton"
  },
  {
    id: 247,
    question: "Which pigment gives red blood cells their characteristic color?",
    options: ["Chlorophyll", "Melanin", "Hemoglobin", "Carotene"],
    answer: "Hemoglobin"
  },
  {
    id: 248,
    question: "What is the biological term for a fertilized egg cell?",
    options: ["Zygote", "Embryo", "Blastocyst", "Gamete"],
    answer: "Zygote"
  },
  {
    id: 249,
    question: "Which kingdom includes organisms such as yeasts, molds, and mushrooms?",
    options: ["Plantae", "Animalia", "Fungi", "Protista"],
    answer: "Fungi"
  },
  {
    id: 250,
    question: "What is the primary site of nutrient absorption in the human digestive tract?",
    options: ["Stomach", "Large intestine", "Small intestine", "Esophagus"],
    answer: "Small intestine"
  },
  {
    id: 251,
    question: "Which biomolecule group includes fats, oils, and waxes?",
    options: ["Carbohydrates", "Proteins", "Lipids", "Nucleic acids"],
    answer: "Lipids"
  },
  {
    id: 252,
    question: "What is the long, thread-like part of a nerve cell that conducts electrical impulses away from the cell body?",
    options: ["Dendrite", "Axon", "Synapse", "Myelin"],
    answer: "Axon"
  },
  {
    id: 253,
    question: "Which term describes a community of living organisms interacting with their physical environment?",
    options: ["Population", "Biosphere", "Ecosystem", "Biome"],
    answer: "Ecosystem"
  },
  {
    id: 254,
    question: "What is the process by which white blood cells engulf and digest foreign particles and pathogens?",
    options: ["Pinocytosis", "Phagocytosis", "Exocytosis", "Osmosis"],
    answer: "Phagocytosis"
  },
  {
    id: 255,
    question: "Which structural protein is abundant in hair, nails, and outer skin layers?",
    options: ["Collagen", "Keratin", "Elastin", "Fibrin"],
    answer: "Keratin"
  },
  {
    id: 256,
    question: "What is the term for a sudden, heritable change in chromosome number or structure?",
    options: ["Chromosomal mutation", "Point mutation", "Gene duplication", "Crossing over"],
    answer: "Chromosomal mutation"
  },
  {
    id: 257,
    question: "Which enzyme is responsible for synthesizing RNA from a DNA template during transcription?",
    options: ["DNA polymerase", "RNA polymerase", "Helicase", "Ligase"],
    answer: "RNA polymerase"
  },
  {
    id: 258,
    question: "What is the main function of the large intestine?",
    options: ["Protein digestion", "Water absorption", "Nutrient absorption", "Bile production"],
    answer: "Water absorption"
  },
  {
    id: 259,
    question: "Which vascular plant group reproduces using spores rather than seeds and lacks flowers?",
    options: ["Gymnosperms", "Angiosperms", "Ferns", "Mosses"],
    answer: "Ferns"
  },
  {
    id: 260,
    question: "What is the term for the maintenance of a stable internal environment in living organisms?",
    options: ["Metabolism", "Homeostasis", "Osmoregulation", "Catabolism"],
    answer: "Homeostasis"
  },
  {
    id: 261,
    question: "Which specific structure within the chloroplast absorbs light energy for photosynthesis?",
    options: ["Stroma", "Thylakoid", "Cristae", "Matrix"],
    answer: "Thylakoid"
  },
  {
    id: 262,
    question: "What type of bonds hold the two strands of a DNA double helix together?",
    options: ["Covalent bonds", "Hydrogen bonds", "Ionic bonds", "Peptide bonds"],
    answer: "Hydrogen bonds"
  },
  {
    id: 263,
    question: "Which blood component is essential for blood clotting?",
    options: ["Erythrocytes", "Leukocytes", "Platelets", "Plasma"],
    answer: "Platelets"
  },
  {
    id: 264,
    question: "What is the name of the muscular valve separating the stomach from the small intestine?",
    options: ["Cardiac sphincter", "Pyloric sphincter", "Ileocecal valve", "Anal sphincter"],
    answer: "Pyloric sphincter"
  },
  {
    id: 265,
    question: "Which evolutionary term describes structures that share a common ancestry regardless of their current function?",
    options: ["Analogous structures", "Homologous structures", "Vestigial structures", "Convergent structures"],
    answer: "Homologous structures"
  },
  {
    id: 266,
    question: "What is the primary role of tRNA during protein synthesis?",
    options: ["Carry genetic code from nucleus", "Bring amino acids to the ribosome", "Form the core of the ribosome", "Unwind the DNA double helix"],
    answer: "Bring amino acids to the ribosome"
  },
  {
    id: 267,
    question: "Which hormone stimulates the 'fight or flight' response in stressful situations?",
    options: ["Insulin", "Adrenaline (Epinephrine)", "Melatonin", "Thyroxine"],
    answer: "Adrenaline (Epinephrine)"
  },
  {
    id: 268,
    question: "What is the term for an animal that maintains its internal body temperature using metabolic heat?",
    options: ["Ectotherm", "Endotherm", "Poikilotherm", "Amphibian"],
    answer: "Endotherm"
  },
  {
    id: 269,
    question: "Which organelle is responsible for modifying, sorting, and packaging proteins for secretion?",
    options: ["Endoplasmic reticulum", "Golgi apparatus", "Lysosome", "Ribosome"],
    answer: "Golgi apparatus"
  },
  {
    id: 270,
    question: "What is the chemical equation summary for aerobic cellular respiration?",
    options: ["Glucose + Oxygen -> Carbon Dioxide + Water + ATP", "Carbon Dioxide + Water -> Glucose + Oxygen", "Glucose -> Lactic Acid + ATP", "Glucose -> Ethanol + Carbon Dioxide"],
    answer: "Glucose + Oxygen -> Carbon Dioxide + Water + ATP"
  },
  {
    id: 271,
    question: "Which specific phase of mitosis involves chromosomes lining up along the equator of the cell?",
    options: ["Prophase", "Metaphase", "Anaphase", "Telophase"],
    answer: "Metaphase"
  },
  {
    id: 272,
    question: "What is the primary pigment responsible for skin color in humans?",
    options: ["Hemoglobin", "Carotene", "Melanin", "Chlorophyll"],
    answer: "Melanin"
  },
  {
    id: 273,
    question: "Which plant hormone promotes cell elongation and tropisms such as phototropism?",
    options: ["Cytokinin", "Auxin", "Ethylene", "Abscisic acid"],
    answer: "Auxin"
  },
  {
    id: 274,
    question: "What type of immunity is acquired through natural infection or vaccination?",
    options: ["Innate immunity", "Active immunity", "Passive immunity", "Inborn immunity"],
    answer: "Active immunity"
  },
  {
    id: 275,
    question: "What is the term for the full set of genes in an organism?",
    options: ["Proteome", "Genome", "Karyotype", "Phenome"],
    answer: "Genome"
  },
  {
    id: 276,
    question: "Which chamber of the mammalian heart pumps oxygenated blood to the rest of the body?",
    options: ["Right atrium", "Right ventricle", "Left atrium", "Left ventricle"],
    answer: "Left ventricle"
  },
  {
    id: 277,
    question: "What is the process where cells program their own death during development or tissue homeostasis?",
    options: ["Necrosis", "Apoptosis", "Mitosis", "Pinocytosis"],
    answer: "Apoptosis"
  },
  {
    id: 278,
    question: "Which class of vertebrates is characterized by having moist skin and undergoing metamorphosis from water-breathing larvae to land-dwelling adults?",
    options: ["Reptiles", "Amphibians", "Birds", "Mammals"],
    answer: "Amphibians"
  },
  {
    id: 279,
    question: "What is the name of the process that converts nitrogen gas from the atmosphere into ammonia in soil?",
    options: ["Nitrification", "Denitrification", "Nitrogen fixation", "Ammonification"],
    answer: "Nitrogen fixation"
  },
  {
    id: 280,
    question: "Which nucleic acid contains the base uracil instead of thymine?",
    options: ["DNA", "RNA", "Both DNA and RNA", "Plasmid"],
    answer: "RNA"
  },
  {
    id: 281,
    question: "What is the outer protective layer of woody stems and roots called?",
    options: ["Bark", "Heartwood", "Pith", "Cambium"],
    answer: "Bark"
  },
  {
    id: 282,
    question: "Which structure connects bones to other bones in the human skeletal system?",
    options: ["Tendon", "Ligament", "Cartilage", "Joint capsule"],
    answer: "Ligament"
  },
  {
    id: 283,
    question: "What term describes species that play a disproportionately large role in maintaining the structure of an ecological community?",
    options: ["Endemic species", "Keystone species", "Invasive species", "Pioneer species"],
    answer: "Keystone species"
  },
  {
    id: 284,
    question: "Which enzyme is responsible for unwinding the DNA double helix during replication?",
    options: ["DNA polymerase", "DNA helicase", "RNA polymerase", "DNA ligase"],
    answer: "DNA helicase"
  },
  {
    id: 285,
    question: "What is the primary nitrogenous waste product excreted by humans and most mammals?",
    options: ["Ammonia", "Uric acid", "Urea", "Creatinine"],
    answer: "Urea"
  },
  {
    id: 286,
    question: "Which visual cells in the retina are responsible for color vision in bright light?",
    options: ["Rods", "Cones", "Ganglion cells", "Bipolar cells"],
    answer: "Cones"
  },
  {
    id: 287,
    question: "What is the term for a close, long-term biological interaction between two different biological species?",
    options: ["Predation", "Symbiosis", "Competition", "Succession"],
    answer: "Symbiosis"
  },
  {
    id: 288,
    question: "Which plant organ is primarily responsible for absorbing water and mineral nutrients from the soil?",
    options: ["Leaf", "Stem", "Root", "Flower"],
    answer: "Root"
  },
  {
    id: 289,
    question: "What is the name of the fluid-filled space inside mitochondria where the Krebs cycle takes place?",
    options: ["Stroma", "Thylakoid lumen", "Matrix", "Cytosol"],
    answer: "Matrix"
  },
  {
    id: 290,
    question: "Which disease-causing agent is non-living and consists only of genetic material encased in protein?",
    options: ["Bacterium", "Fungus", "Virus", "Protozoan"],
    answer: "Virus"
  },
  {
    id: 291,
    question: "What is the structural and functional unit of the nervous system?",
    options: ["Nephron", "Neuron", "Alveolus", "Myofibril"],
    answer: "Neuron"
  },
  {
    id: 292,
    question: "Which term describes the physical expression of a genetic trait?",
    options: ["Genotype", "Phenotype", "Allele", "Locus"],
    answer: "Phenotype"
  },
  {
    id: 293,
    question: "What is the primary function of red bone marrow?",
    options: ["Store fat", "Produce blood cells", "Support bone structure", "Produce hormones"],
    answer: "Produce blood cells"
  },
  {
    id: 294,
    question: "Which vascular plant group produces seeds enclosed within a fruit or flower?",
    options: ["Gymnosperms", "Angiosperms", "Ferns", "Bryophytes"],
    answer: "Angiosperms"
  },
  {
    id: 295,
    question: "What is the name of the valve between the right atrium and right ventricle of the heart?",
    options: ["Mitral valve", "Aortic valve", "Tricuspid valve", "Pulmonary valve"],
    answer: "Tricuspid valve"
  },
  {
    id: 296,
    question: "Which biological process converts sugar into acids, gases, or alcohol in the absence of oxygen?",
    options: ["Photosynthesis", "Fermentation", "Respiration", "Transpiration"],
    answer: "Fermentation"
  },
  {
    id: 297,
    question: "What is the term for the replacement of an ecological community by a new group of species over time?",
    options: ["Evolution", "Adaptation", "Ecological succession", "Speciation"],
    answer: "Ecological succession"
  },
  {
    id: 298,
    question: "Which specialized protein complex links adjacent animal cells together, forming a waterproof barrier?",
    options: ["Gap junction", "Desmosome", "Tight junction", "Plasmodesmata"],
    answer: "Tight junction"
  },
  {
    id: 299,
    question: "What is the main function of the cerebellum?",
    options: ["Regulate breathing", "Control balance and motor coordination", "Process visual information", "Regulate body temperature"],
    answer: "Control balance and motor coordination"
  },
  {
    id: 300,
    question: "Which cellular organelle contains hydrolytic enzymes and is heavily involved in autophagy?",
    options: ["Ribosome", "Lysosome", "Peroxisome", "Centrosome"],
    answer: "Lysosome"
  },
  {
    id: 301,
    question: "What does CPU stand for in computer science?",
    options: ["Central Processing Unit", "Computer Personal Unit", "Central Program Utility", "Control Processing Unit"],
    answer: "Central Processing Unit"
  },
  {
    id: 302,
    question: "Which data structure operates on a Last-In, First-Out (LIFO) basis?",
    options: ["Queue", "Stack", "Array", "Tree"],
    answer: "Stack"
  },
  {
    id: 303,
    question: "What is the time complexity of binary search on a sorted array of size n?",
    options: ["O(n)", "O(n log n)", "O(log n)", "O(1)"],
    answer: "O(log n)"
  },
  {
    id: 304,
    question: "Which programming paradigm treats computation as the evaluation of mathematical functions?",
    options: ["Object-Oriented Programming", "Procedural Programming", "Functional Programming", "Imperative Programming"],
    answer: "Functional Programming"
  },
  {
    id: 305,
    question: "What protocol is primarily used to securely transmit web pages over the internet?",
    options: ["HTTP", "FTP", "HTTPS", "SMTP"],
    answer: "HTTPS"
  },
  {
    id: 306,
    question: "Which database type uses tables with rows and columns to store structured data?",
    options: ["NoSQL Database", "Relational Database", "Graph Database", "Hierarchical Database"],
    answer: "Relational Database"
  },
  {
    id: 307,
    question: "What is the main purpose of an operating system's kernel?",
    options: ["Manage web browsers", "Handle system hardware and core resource management", "Design user interfaces", "Compile source code"],
    answer: "Handle system hardware and core resource management"
  },
  {
    id: 308,
    question: "Which sorting algorithm has a worst-case time complexity of O(n^2) and works by repeatedly swapping adjacent elements?",
    options: ["Merge Sort", "Quick Sort", "Bubble Sort", "Heap Sort"],
    answer: "Bubble Sort"
  },
  {
    id: 309,
    question: "What does HTML stand for in web development?",
    options: ["HyperText Transfer Markup Language", "HyperText Markup Language", "High Tech Multi Language", "Hyperlink Transfer Markup Level"],
    answer: "HyperText Markup Language"
  },
  {
    id: 310,
    question: "Which principle of Object-Oriented Programming restricts direct access to some of an object's components?",
    options: ["Inheritance", "Polymorphism", "Encapsulation", "Abstractions"],
    answer: "Encapsulation"
  },
  {
    id: 311,
    question: "What is the binary representation of the decimal number 5?",
    options: ["101", "110", "111", "100"],
    answer: "101"
  },
  {
    id: 312,
    question: "Which network topology connects all devices to a central hub or switch?",
    options: ["Bus topology", "Ring topology", "Star topology", "Mesh topology"],
    answer: "Star topology"
  },
  {
    id: 313,
    question: "What data structure uses a First-In, First-Out (FIFO) approach?",
    options: ["Stack", "Queue", "Tree", "Graph"],
    answer: "Queue"
  },
  {
    id: 314,
    question: "Which computer science concept allows a function to call itself?",
    options: ["Iteration", "Recursion", "Encapsulation", "Inheritance"],
    answer: "Recursion"
  },
  {
    id: 315,
    question: "What does SQL stand for?",
    options: ["Simple Query Logic", "Structured Query Language", "System Quality Link", "Standard Query Level"],
    answer: "Structured Query Language"
  },
  {
    id: 316,
    question: "Which layer of the OSI model is responsible for routing data packets across different networks?",
    options: ["Physical layer", "Data link layer", "Network layer", "Transport layer"],
    answer: "Network layer"
  },
  {
    id: 317,
    question: "What type of memory is volatile and loses its contents when the power is turned off?",
    options: ["ROM", "RAM", "Flash memory", "Hard disk drive"],
    answer: "RAM"
  },
  {
    id: 318,
    question: "Which sorting algorithm is an example of a divide-and-conquer algorithm?",
    options: ["Selection sort", "Insertion sort", "Merge sort", "Bubble sort"],
    answer: "Merge sort"
  },
  {
    id: 319,
    question: "What is the primary function of a compiler?",
    options: ["Execute code line by line", "Translate source code into machine code all at once", "Manage computer files", "Connect to networks"],
    answer: "Translate source code into machine code all at once"
  },
  {
    id: 320,
    question: "Which object-oriented concept allows a new class to inherit properties and methods from an existing class?",
    options: ["Polymorphism", "Inheritance", "Encapsulation", "Abstraction"],
    answer: "Inheritance"
  },
  {
    id: 321,
    question: "What does API stand for in software development?",
    options: ["Application Programming Interface", "Advanced Program Integration", "Automated Process Interaction", "Application Program Interaction"],
    answer: "Application Programming Interface"
  },
  {
    id: 322,
    question: "Which cryptographic algorithm is a symmetric-key block cipher widely used as a standard?",
    options: ["RSA", "AES", "Diffie-Hellman", "ECC"],
    answer: "AES"
  },
  {
    id: 323,
    question: "What graph traversal algorithm uses a queue to explore nodes level by level?",
    options: ["Depth-First Search (DFS)", "Breadth-First Search (BFS)", "Dijkstra's Algorithm", "Bellman-Ford Algorithm"],
    answer: "Breadth-First Search (BFS)"
  },
  {
    id: 324,
    question: "Which component inside a computer performs arithmetic and logical operations?",
    options: ["Control Unit", "ALU (Arithmetic Logic Unit)", "Cache memory", "Registers"],
    answer: "ALU (Arithmetic Logic Unit)"
  },
  {
    id: 325,
    question: "What is the name of the standard version control system created by Linus Torvalds?",
    options: ["Subversion", "Mercurial", "Git", "CVS"],
    answer: "Git"
  },
  {
    id: 326,
    question: "Which protocol is used to send email messages from a client to a server?",
    options: ["POP3", "IMAP", "SMTP", "HTTP"],
    answer: "SMTP"
  },
  {
    id: 327,
    question: "What is a deadlock in operating systems?",
    options: ["A computer crashing due to high temperature", "A situation where two or more processes are blocked waiting for each other to release resources", "A memory leak in background services", "A corrupted hard drive sector"],
    answer: "A situation where two or more processes are blocked waiting for each other to release resources"
  },
  {
    id: 328,
    question: "Which programming language is heavily used for statistical computing and data analysis?",
    options: ["R", "HTML", "CSS", "SQL"],
    answer: "R"
  },
  {
    id: 329,
    question: "What is the time complexity of accessing an element in an array by its index?",
    options: ["O(n)", "O(log n)", "O(1)", "O(n^2)"],
    answer: "O(1)"
  },
  {
    id: 330,
    question: "Which type of malware disguises itself as legitimate software to trick users into installing it?",
    options: ["Worm", "Trojan horse", "Ransomware", "Spyware"],
    answer: "Trojan horse"
  },
  {
    id: 331,
    question: "What does CSS stand for in web design?",
    options: ["Computer Style Sheets", "Cascading Style Sheets", "Creative Style System", "Colorful Style Sheets"],
    answer: "Cascading Style Sheets"
  },
  {
    id: 332,
    question: "Which tree data structure maintains the property that the value of each node is greater than or equal to the values of its children?",
    options: ["Binary Search Tree", "Max-Heap", "Min-Heap", "B-Tree"],
    answer: "Max-Heap"
  },
  {
    id: 333,
    question: "What is the default port number for secure HTTPS traffic?",
    options: ["80", "443", "21", "22"],
    answer: "443"
  },
  {
    id: 334,
    question: "Which software testing level verifies that individual software components work correctly on their own?",
    options: ["Integration testing", "System testing", "Unit testing", "Acceptance testing"],
    answer: "Unit testing"
  },
  {
    id: 335,
    question: "What is the primary function of a router in computer networking?",
    options: ["Forward data packets between different computer networks", "Convert digital signals to analog signals", "Store website files locally", "Block unauthorized external traffic"],
    answer: "Forward data packets between different computer networks"
  },
  {
    id: 336,
    question: "Which term describes the ability of different types of objects to respond to the same message with different behaviors?",
    options: ["Inheritance", "Polymorphism", "Encapsulation", "Abstraction"],
    answer: "Polymorphism"
  },
  {
    id: 337,
    question: "What does JSON stand for?",
    options: ["JavaScript Object Notation", "Java Standard Output Node", "Junction Scripting Object Name", "JavaScript Oriented Network"],
    answer: "JavaScript Object Notation"
  },
  {
    id: 338,
    question: "Which hash collision resolution method involves storing colliding elements in a linked list at the same index?",
    options: ["Linear probing", "Quadratic probing", "Chaining", "Double hashing"],
    answer: "Chaining"
  },
  {
    id: 339,
    question: "What is the maximum decimal value that can be represented by a single byte (8 bits)?",
    options: ["127", "255", "511", "1023"],
    answer: "255"
  },
  {
    id: 340,
    question: "Which cloud computing service model provides virtualized computing resources over the internet?",
    options: ["SaaS", "PaaS", "IaaS", "DaaS"],
    answer: "IaaS"
  },
  {
    id: 341,
    question: "What is a primary key in a relational database?",
    options: ["A key used to encrypt passwords", "A unique identifier for each record in a table", "A pointer to an external file", "A foreign link to another database"],
    answer: "A unique identifier for each record in a table"
  },
  {
    id: 342,
    question: "Which programming language was originally developed by Bjarne Stroustrup as an extension of C?",
    options: ["C#", "C++", "Objective-C", "D"],
    answer: "C++"
  },
  {
    id: 343,
    question: "What does DNS stand for in networking architecture?",
    options: ["Domain Name System", "Data Network Service", "Digital Name Server", "Dynamic Network Switch"],
    answer: "Domain Name System"
  },
  {
    id: 344,
    question: "Which search algorithm explores as deep as possible along each branch before backtracking?",
    options: ["Breadth-First Search", "Depth-First Search", "Linear Search", "Binary Search"],
    answer: "Depth-First Search"
  },
  {
    id: 345,
    question: "What is the term for a program that runs continuously on a server to wait for and respond to incoming requests?",
    options: ["Daemon (or Service)", "Driver", "Compiler", "Debugger"],
    answer: "Daemon (or Service)"
  },
  {
    id: 346,
    question: "Which software development methodology emphasizes iterative progress, collaboration, and cross-functional teams?",
    options: ["Waterfall", "Agile", "Spiral", "V-Model"],
    answer: "Agile"
  },
  {
    id: 347,
    question: "What is the main difference between TCP and UDP?",
    options: ["TCP is connection-oriented and reliable; UDP is connectionless and faster", "UDP is more secure than TCP", "TCP only works on local networks", "UDP requires a handshake before sending data"],
    answer: "TCP is connection-oriented and reliable; UDP is connectionless and faster"
  },
  {
    id: 348,
    question: "Which data structure uses key-value pairs and allows for rapid retrieval based on keys?",
    options: ["Array", "Linked List", "Hash Table", "Queue"],
    answer: "Hash Table"
  },
  {
    id: 349,
    question: "What does the acronym RAM stand for?",
    options: ["Readily Accessible Memory", "Random Access Memory", "Rapid Allocation Module", "Real-time Active Mechanism"],
    answer: "Random Access Memory"
  },
  {
    id: 350,
    question: "Which algorithm is used to find the shortest path between nodes in a graph with non-negative edge weights?",
    options: ["Kruskal's algorithm", "Prim's algorithm", "Dijkstra's algorithm", "Floyd-Warshall algorithm"],
    answer: "Dijkstra's algorithm"
  },
  {
    id: 351,
    question: "What is an interpreter's primary role compared to a compiler?",
    options: ["Translate and execute code line by line", "Generate binary files", "Optimize machine performance", "Run operating systems"],
    answer: "Translate and execute code line by line"
  },
  {
    id: 352,
    question: "Which type of inheritance occurs when a class inherits from more than one parent class?",
    options: ["Single inheritance", "Multilevel inheritance", "Multiple inheritance", "Hierarchical inheritance"],
    answer: "Multiple inheritance"
  },
  {
    id: 353,
    question: "What does URL stand for?",
    options: ["Universal Resource Locator", "Uniform Resource Locator", "Unified Retrieval Link", "Uniform Record Locator"],
    answer: "Uniform Resource Locator"
  },
  {
    id: 354,
    question: "Which normal form in database normalization eliminates transitive dependencies?",
    options: ["First Normal Form (1NF)", "Second Normal Form (2NF)", "Third Normal Form (3NF)", "Boyce-Codd Normal Form (BCNF)"],
    answer: "Third Normal Form (3NF)"
  },
  {
    id: 355,
    question: "What is the term for hiding complex implementation details and showing only essential features?",
    options: ["Encapsulation", "Abstraction", "Polymorphism", "Inheritance"],
    answer: "Abstraction"
  },
  {
    id: 356,
    question: "Which communication protocol is commonly used for IoT devices due to its lightweight publish-subscribe architecture?",
    options: ["HTTP", "MQTT", "FTP", "SSH"],
    answer: "MQTT"
  },
  {
    id: 357,
    question: "What is the worst-case time complexity of QuickSort?",
    options: ["O(n log n)", "O(n)", "O(n^2)", "O(log n)"],
    answer: "O(n^2)"
  },
  {
    id: 358,
    question: "Which operating system core service allocates CPU time slices to active processes?",
    options: ["Scheduler", "File manager", "Memory manager", "Device driver"],
    answer: "Scheduler"
  },
  {
    id: 359,
    question: "What does XML stand for?",
    options: ["Extensible Markup Language", "Extra Modern Link", "Execution Management Language", "External Markup Logic"],
    answer: "Extensible Markup Language"
  },
  {
    id: 360,
    question: "Which memory type is non-volatile and retains data even when power is turned off?",
    options: ["DRAM", "SRAM", "ROM", "Cache"],
    answer: "ROM"
  },
  {
    id: 361,
    question: "What is a pointer in programming languages like C and C++?",
    options: ["A variable that stores the memory address of another variable", "A function that returns boolean values", "An array index counter", "A special keyword for loops"],
    answer: "A variable that stores the memory address of another variable"
  },
  {
    id: 362,
    question: "Which database transaction property ensures that all operations in a transaction succeed or none are applied?",
    options: ["Atomicity", "Consistency", "Isolation", "Durability"],
    answer: "Atomicity"
  },
  {
    id: 363,
    question: "What is the purpose of a firewall in network security?",
    options: ["Prevent computer overheating", "Monitor and control incoming and outgoing network traffic based on predetermined security rules", "Speed up internet connections", "Scan local drives for viruses"],
    answer: "Monitor and control incoming and outgoing network traffic based on predetermined security rules"
  },
  {
    id: 364,
    question: "Which sorting algorithm builds the final sorted array one item at a time by comparisons?",
    options: ["Insertion sort", "Merge sort", "Radix sort", "Bucket sort"],
    answer: "Insertion sort"
  },
  {
    id: 365,
    question: "What does IDE stand for in software development environments?",
    options: ["Integrated Development Environment", "Interface Design Engine", "Internal Data Execution", "Interactive Debugging Entity"],
    answer: "Integrated Development Environment"
  },
  {
    id: 366,
    question: "Which cryptographic method uses two keys: a public key for encryption and a private key for decryption?",
    options: ["Symmetric encryption", "Asymmetric encryption", "Hashing", "Salting"],
    answer: "Asymmetric encryption"
  },
  {
    id: 367,
    question: "What is the time complexity of inserting an element at the beginning of a singly linked list of size n?",
    options: ["O(n)", "O(1)", "O(log n)", "O(n log n)"],
    answer: "O(1)"
  },
  {
    id: 368,
    question: "Which protocol is used to securely log into remote servers over a network?",
    options: ["Telnet", "SSH", "FTP", "HTTP"],
    answer: "SSH"
  },
  {
    id: 369,
    question: "What is a software bug?",
    options: ["An intentional feature", "An error, flaw, or fault in computer software that causes it to produce incorrect or unexpected results", "A hardware manufacturing defect", "A virus written by hackers"],
    answer: "An error, flaw, or fault in computer software that causes it to produce incorrect or unexpected results"
  },
  {
    id: 370,
    question: "Which data structure is best suited for implementing a priority queue?",
    options: ["Stack", "Array", "Heap", "Linked list"],
    answer: "Heap"
  },
  {
    id: 371,
    question: "What does GUI stand for in human-computer interaction?",
    options: ["Graphical User Interface", "General Utility Index", "Guided User Interaction", "Global Unified Integration"],
    answer: "Graphical User Interface"
  },
  {
    id: 372,
    question: "Which algorithmic paradigm breaks a problem down into simpler subproblems, stores the results, and avoids redundant computation?",
    options: ["Greedy algorithm", "Divide and conquer", "Dynamic programming", "Backtracking"],
    answer: "Dynamic programming"
  },
  {
    id: 373,
    question: "What is the function of the `ping` command in networking?",
    options: ["Test the reachability of a host on an IP network", "Download files from a server", "Scan open ports", "Measure CPU temperature"],
    answer: "Test the reachability of a host on an IP network"
  },
  {
    id: 374,
    question: "Which programming language was created by Brendan Eich in 1995 for web browsers?",
    options: ["Python", "Java", "JavaScript", "PHP"],
    answer: "JavaScript"
  },
  {
    id: 375,
    question: "What is memory fragmentation in computer operating systems?",
    options: ["Physical damage to RAM sticks", "Inefficient use of memory space where free memory is split into small non-contiguous blocks", "Corrupted file sectors on a hard drive", "Loss of cache data during power failure"],
    answer: "Inefficient use of memory space where free memory is split into small non-contiguous blocks"
  },
  {
    id: 376,
    question: "Which greedy algorithm is used to find a minimum spanning tree for a connected weighted graph?",
    options: ["Dijkstra's algorithm", "Kruskal's algorithm", "Bellman-Ford algorithm", "Floyd's algorithm"],
    answer: "Kruskal's algorithm"
  },
  {
    id: 377,
    question: "What does SQL injection refer to?",
    options: ["A hardware upgrade technique", "A code injection technique that exploits security vulnerabilities in a database application", "A fast data import method", "An automated database backup routine"],
    answer: "A code injection technique that exploits security vulnerabilities in a database application"
  },
  {
    id: 378,
    question: "Which component of an operating system handles reading and writing data to storage devices?",
    options: ["Network stack", "File system", "Window manager", "Process scheduler"],
    answer: "File system"
  },
  {
    id: 379,
    question: "What is the space complexity of a recursive function that makes n recursive calls linearly without tail call optimization?",
    options: ["O(1)", "O(log n)", "O(n)", "O(n^2)"],
    answer: "O(n)"
  },
  {
    id: 380,
    question: "Which protocol translates private IP addresses to a public IP address for internet routing?",
    options: ["DHCP", "NAT (Network Address Translation)", "ARP", "ICMP"],
    answer: "NAT (Network Address Translation)"
  },
  {
    id: 381,
    question: "What is the main advantage of using hash tables over arrays for searching items?",
    options: ["Hash tables use less memory", "Hash tables provide average O(1) time complexity for searches", "Hash tables keep elements sorted automatically", "Hash tables do not experience collisions"],
    answer: "Hash tables provide average O(1) time complexity for searches"
  },
  {
    id: 382,
    question: "Which software design pattern restricts instantiation of a class to a single instance?",
    options: ["Factory pattern", "Observer pattern", "Singleton pattern", "Decorator pattern"],
    answer: "Singleton pattern"
  },
  {
    id: 383,
    question: "What does CPU cache do?",
    options: ["Provides permanent storage for user files", "Stores frequently used instructions and data close to the CPU for faster access", "Manages external USB devices", "Controls screen resolution"],
    answer: "Stores frequently used instructions and data close to the CPU for faster access"
  },
  {
    id: 384,
    question: "Which sorting algorithm is non-comparative and sorts data by grouping keys by individual digits?",
    options: ["Merge sort", "Radix sort", "Quick sort", "Heap sort"],
    answer: "Radix sort"
  },
  {
    id: 385,
    question: "What is an abstract class in object-oriented programming?",
    options: ["A class that cannot be instantiated directly and often contains abstract methods to be implemented by subclasses", "A class with no methods or properties", "A class that can only have one object created", "A hidden system class"],
    answer: "A class that cannot be instantiated directly and often contains abstract methods to be implemented by subclasses"
  },
  {
    id: 386,
    question: "What does the acronym SSD stand for in computer hardware?",
    options: ["Solid State Drive", "System Storage Device", "Super Speed Disk", "Serial Storage Driver"],
    answer: "Solid State Drive"
  },
  {
    id: 387,
    question: "Which network layer protocol is responsible for reliable, ordered, and error-checked delivery of streams of octets?",
    options: ["IP", "TCP", "UDP", "ICMP"],
    answer: "TCP"
  },
  {
    id: 388,
    question: "What is refactoring in software engineering?",
    options: ["Rewriting software entirely from scratch without documentation", "The process of restructuring existing computer code without changing its external behavior", "Fixing hardware components", "Deploying code to production servers"],
    answer: "The process of restructuring existing computer code without changing its external behavior"
  },
  {
    id: 389,
    question: "Which data structure is ideal for evaluating arithmetic expressions and syntax parsing?",
    options: ["Queue", "Stack", "Array", "Graph"],
    answer: "Stack"
  },
  {
    id: 390,
    question: "What is the purpose of an index in a database?",
    options: ["Encrypt sensitive column data", "Speed up the retrieval of rows from a table at the cost of write performance", "Manage user permissions", "Store database logs"],
    answer: "Speed up the retrieval of rows from a table at the cost of write performance"
  },
  {
    id: 391,
    question: "Which term describes a network attack where a malicious actor intercepts communication between two parties?",
    options: ["DDoS attack", "Man-in-the-middle (MitM) attack", "Phishing", "SQL injection"],
    answer: "Man-in-the-middle (MitM) attack"
  },
  {
    id: 392,
    question: "What is the time complexity of merging two sorted arrays of sizes n and m?",
    options: ["O(n * m)", "O(n + m)", "O(n log m)", "O(1)"],
    answer: "O(n + m)"
  },
  {
    id: 393,
    question: "Which programming language is commonly used for system programming, game development, and operating systems due to its high performance and memory control?",
    options: ["Python", "JavaScript", "C", "Ruby"],
    answer: "C"
  },
  {
    id: 394,
    question: "What is virtual memory in operating systems?",
    options: ["Cloud storage space provided by Google or Microsoft", "A memory management capability that uses hardware and software to allow a computer to compensate for physical memory shortages by temporarily transferring data to disk storage", "RAM installed in virtual machines", "Graphics card video memory"],
    answer: "A memory management capability that uses hardware and software to allow a computer to compensate for physical memory shortages by temporarily transferring data to disk storage"
  },
  {
    id: 395,
    question: "What does the term 'open-source software' mean?",
    options: ["Software that is free to use but source code is hidden", "Software whose source code is made freely available and may be redistributed and modified", "Software that runs only on open operating systems", "Software developed by government agencies"],
    answer: "Software whose source code is made freely available and may be redistributed and modified"
  },
  {
    id: 396,
    question: "Which design pattern defines a subscription mechanism to notify multiple objects about any events that happen to the object they're observing?",
    options: ["Singleton", "Observer", "Factory", "Adapter"],
    answer: "Observer"
  },
  {
    id: 397,
    question: "What is the primary role of a subnet mask in IPv4 networking?",
    options: ["Encrypt network packets", "Divide an IP address into network and host addresses", "Assign dynamic IP addresses to devices", "Translate domain names to IP addresses"],
    answer: "Divide an IP address into network and host addresses"
  },
  {
    id: 398,
    question: "Which graph representation uses a 2D array to indicate whether pairs of vertices are adjacent or not?",
    options: ["Adjacency list", "Adjacency matrix", "Edge list", "Incidence tree"],
    answer: "Adjacency matrix"
  },
  {
    id: 399,
    question: "What does OOP stand for in programming?",
    options: ["Object-Oriented Programming", "Online Operation Protocol", "Ordered Object Processing", "Open Output Pipeline"],
    answer: "Object-Oriented Programming"
  },
  {
    id: 400,
    question: "Which sorting algorithm consistently achieves O(n log n) time complexity and divides the array into halves recursively?",
    options: ["Bubble sort", "Insertion sort", "Merge sort", "Selection sort"],
    answer: "Merge sort"
  },
  {
    id: 401,
    question: "What is a thread in computer operating systems?",
    options: ["A physical wire inside the processor", "The smallest unit of execution within a process", "A background virus scanner", "An idle memory block"],
    answer: "The smallest unit of execution within a process"
  },
  {
    id: 402,
    question: "Which protocol dynamically assigns IP addresses to devices on a network?",
    options: ["DNS", "DHCP", "FTP", "SMTP"],
    answer: "DHCP"
  },
  {
    id: 403,
    question: "What is the worst-case time complexity of searching in a binary search tree (BST) that has degenerated into a linear chain?",
    options: ["O(1)", "O(log n)", "O(n)", "O(n log n)"],
    answer: "O(n)"
  },
  {
    id: 404,
    question: "Which principle of the SOLID design principles states that a class should have only one reason to change?",
    options: ["Single Responsibility Principle", "Open-Closed Principle", "Liskov Substitution Principle", "Interface Segregation Principle"],
    answer: "Single Responsibility Principle"
  },
  {
    id: 405,
    question: "What does CPU pipeline execution aim to achieve?",
    options: ["Reduce power consumption", "Increase instruction throughput by overlapping steps of multiple instructions", "Double the size of RAM", "Prevent system overheating"],
    answer: "Increase instruction throughput by overlapping steps of multiple instructions"
  },
  {
    id: 406,
    question: "Which data structure is typically used to implement LRU (Least Recently Used) cache eviction policy efficiently?",
    options: ["Array and Stack", "Hash Map and Doubly Linked List", "Binary Search Tree", "Queue only"],
    answer: "Hash Map and Doubly Linked List"
  },
  {
    id: 407,
    question: "What is continuous integration (CI) in software development?",
    options: ["Writing code without taking breaks", "The practice of automatically merging all developer working copies to a shared mainline frequently", "Running manual unit tests once a year", "Releasing software updates exclusively on physical CDs"],
    answer: "The practice of automatically merging all developer working copies to a shared mainline frequently"
  },
  {
    id: 408,
    question: "Which data type modifier represents true or false values in most programming languages?",
    options: ["Integer", "Float", "Boolean", "Char"],
    answer: "Boolean"
  },
  {
    id: 409,
    question: "What is a syntax error?",
    options: ["An error that occurs during program execution due to bad user input", "An error in the source code, such as a typo or missing punctuation, that violates the grammar rules of the programming language", "A hardware component failure", "A slow network connection"],
    answer: "An error in the source code, such as a typo or missing punctuation, that violates the grammar rules of the programming language"
  },
  {
    id: 410,
    question: "Which cloud computing model offers fully managed software applications delivered over the internet on a subscription basis?",
    options: ["IaaS", "PaaS", "SaaS", "DaaS"],
    answer: "SaaS"
  },
  {
    id: 411,
    question: "What is the time complexity of searching for an element in a hash table in the worst-case scenario?",
    options: ["O(1)", "O(log n)", "O(n)", "O(n log n)"],
    answer: "O(n)"
  },
  {
    id: 412,
    question: "Which network device operates at the Data Link layer (Layer 2) and forwards frames based on MAC addresses?",
    options: ["Hub", "Router", "Switch", "Gateway"],
    answer: "Switch"
  },
  {
    id: 413,
    question: "What is garbage collection in programming languages like Java and C#?",
    options: ["Deleting temporary text files from the desktop", "Automatic memory management that reclaims heap memory occupied by objects that are no longer in use", "Clearing browser cache data", "Formatting the hard drive"],
    answer: "Automatic memory management that reclaims heap memory occupied by objects that are no longer in use"
  },
  {
    id: 414,
    question: "Which sorting algorithm repeatedly finds the minimum element from the unsorted part and puts it at the beginning?",
    options: ["Bubble sort", "Selection sort", "Insertion sort", "Quick sort"],
    answer: "Selection sort"
  },
  {
    id: 415,
    question: "What does CRUD stand for in database management and software applications?",
    options: ["Create, Read, Update, Delete", "Copy, Run, Underline, Document", "Compile, Register, Upload, Debug", "Connect, Route, Unpack, Distribute"],
    answer: "Create, Read, Update, Delete"
  },
  {
    id: 416,
    question: "Which programming paradigm focuses on writing code that describes what needs to be accomplished rather than how to accomplish it step-by-step?",
    options: ["Imperative programming", "Declarative programming", "Procedural programming", "Object-oriented programming"],
    answer: "Declarative programming"
  },
  {
    id: 417,
    question: "What is a race condition in concurrent programming?",
    options: ["A competition between two CPU cores for processing speed", "An undesirable situation that occurs when a device or system attempts to perform two or more operations at the same time, but the operations must be done in the proper sequence to affect correct execution", "A network ping contest between servers", "A race condition in disk read speeds"],
    answer: "An undesirable situation that occurs when a device or system attempts to perform two or more operations at the same time, but the operations must be done in the proper sequence to affect correct execution"
  },
  {
    id: 418,
    question: "Which traversal method visits the root node first, then the left subtree, and finally the right subtree in a binary tree?",
    options: ["In-order traversal", "Pre-order traversal", "Post-order traversal", "Level-order traversal"],
    answer: "Pre-order traversal"
  },
  {
    id: 419,
    question: "What is the primary purpose of a load balancer in web architecture?",
    options: ["Compress image files for faster loading", "Distribute incoming network traffic across multiple servers to ensure reliability and responsiveness", "Store encrypted database passwords", "Encrypt user passwords"],
    answer: "Distribute incoming network traffic across multiple servers to ensure reliability and responsiveness"
  },
  {
    id: 420,
    question: "Which security threat involves flooding a target server with internet traffic to overwhelm its resources and disrupt service?",
    options: ["Phishing", "Man-in-the-middle", "DDoS (Distributed Denial of Service)", "SQL Injection"],
    answer: "DDoS (Distributed Denial of Service)"
  },
  {
    id: 421,
    question: "What is the time complexity of deleting a node from a balanced binary search tree (like an AVL tree) with n nodes?",
    options: ["O(1)", "O(log n)", "O(n)", "O(n^2)"],
    answer: "O(log n)"
  },
  {
    id: 422,
    question: "Which principle of the SOLID principles states that subclasses should be substitutable for their base classes without altering correctness?",
    options: ["Open-Closed Principle", "Liskov Substitution Principle", "Interface Segregation Principle", "Dependency Inversion Principle"],
    answer: "Liskov Substitution Principle"
  },
  {
    id: 423,
    question: "What does the term 'latency' mean in computer networking?",
    options: ["The total data storage capacity of a hard drive", "The time delay between a user action and the resulting response on a network", "The speed at which a CPU executes assembly instructions", "The maximum bandwidth available on a fiber line"],
    answer: "The time delay between a user action and the resulting response on a network"
  },
  {
    id: 424,
    question: "Which programming language was created by Guido van Rossum and emphasizes code readability with significant indentation?",
    options: ["Java", "C++", "Python", "Rust"],
    answer: "Python"
  },
  {
    id: 425,
    question: "What is a mutex (mutual exclusion object) used for in multi-threaded programming?",
    options: ["Accelerating thread execution speed", "Synchronizing access to shared resources to prevent race conditions", "Allocating virtual memory blocks", "Compressing thread logs"],
    answer: "Synchronizing access to shared resources to prevent race conditions"
  },
  {
    id: 426,
    question: "Which graph algorithm is used to detect negative weight cycles in a graph?",
    options: ["Dijkstra's algorithm", "Bellman-Ford algorithm", "Kruskal's algorithm", "Prim's algorithm"],
    answer: "Bellman-Ford algorithm"
  },
  {
    id: 427,
    question: "What does REST stand for in web API design?",
    options: ["Representational State Transfer", "Remote System Transfer", "Reliable Service Transfer Protocol", "Rapid Execution Standard Tool"],
    answer: "Representational State Transfer"
  },
  {
    id: 428,
    question: "Which data structure can be implemented using either an array or linked list and processes elements in FIFO order?",
    options: ["Stack", "Queue", "Tree", "Set"],
    answer: "Queue"
  },
  {
    id: 429,
    question: "What is a segmentation fault?",
    options: ["A hardware error in network interface cards", "A specific kind of error caused by accessing memory that is not allowed to be accessed by a program", "A compilation warning for unused variables", "A slow database query"],
    answer: "A specific kind of error caused by accessing memory that is not allowed to be accessed by a program"
  },
  {
    id: 430,
    question: "Which cloud service model provides developers with tools, runtimes, and databases to build and deploy applications without managing underlying infrastructure?",
    options: ["IaaS", "PaaS", "SaaS", "NaaS"],
    answer: "PaaS"
  },
  {
    id: 431,
    question: "What is the primary function of a linker in compiling software?",
    options: ["Translate source code to assembly", "Combine various object files and libraries into a single executable program", "Format source code indentation", "Check code formatting style"],
    answer: "Combine various object files and libraries into a single executable program"
  },
  {
    id: 432,
    question: "Which design pattern is a creational pattern that provides an interface for creating objects in a superclass, but allows subclasses to alter the type of objects that will be created?",
    options: ["Singleton", "Factory Method", "Observer", "Strategy"],
    answer: "Factory Method"
  },
  {
    id: 433,
    question: "What is the time complexity of pushing an element onto a dynamic array stack when resizing is triggered?",
    options: ["O(1) amortized", "O(n) worst-case always", "O(log n)", "O(n^2)"],
    answer: "O(1) amortized"
  },
  {
    id: 434,
    question: "Which protocol is used for transferring files between computers over a TCP/IP network?",
    options: ["FTP", "SMTP", "HTTP", "SNMP"],
    answer: "FTP"
  },
  {
    id: 435,
    question: "What is polymorphism in object-oriented programming?",
    options: ["Writing code that runs on multiple operating systems", "The ability of different classes to respond to the same method call with distinct implementations", "Hiding object data fields", "Inheriting attributes from multiple classes"],
    answer: "The ability of different classes to respond to the same method call with distinct implementations"
  },
  {
    id: 436,
    question: "Which hardware component stores temporary runtime data that the CPU needs immediately?",
    options: ["Hard disk drive", "RAM", "Power supply unit", "Graphics card cooler"],
    answer: "RAM"
  },
  {
    id: 437,
    question: "What does the acronym IP stand for in networking?",
    options: ["Internal Process", "Internet Protocol", "Information Packet", "Interconnection Port"],
    answer: "Internet Protocol"
  },
  {
    id: 438,
    question: "Which sorting algorithm is generally considered the fastest comparison-based sorting algorithm in practice for random data?",
    options: ["Bubble sort", "Insertion sort", "Quicksort", "Selection sort"],
    answer: "Quicksort"
  },
  {
    id: 439,
    question: "What is code coverage in software testing?",
    options: ["The number of lines of code written per day", "A metric that measures the percentage of source code executed by a test suite", "The insurance policy covering software patents", "The amount of documentation provided"],
    answer: "A metric that measures the percentage of source code executed by a test suite"
  },
  {
    id: 440,
    question: "Which data structure uses parent-child relationships with a single root node and no cycles?",
    options: ["Graph", "Tree", "Hash Table", "Matrix"],
    answer: "Tree"
  },
  {
    id: 441,
    question: "What is the role of an assembler in computer architecture?",
    options: ["Convert assembly language code into machine code", "Combine separate modules into an executable", "Interpret high-level Python code", "Manage network routing tables"],
    answer: "Convert assembly language code into machine code"
  },
  {
    id: 442,
    question: "Which database isolation level prevents dirty reads, non-repeatable reads, and phantom reads?",
    options: ["Read Uncommitted", "Read Committed", "Repeatable Read", "Serializable"],
    answer: "Serializable"
  },
  {
    id: 443,
    question: "What is a cookie in web development?",
    options: ["A programming library for animations", "A small piece of data stored on the user's computer by the web browser while browsing a website", "A security certificate for HTTPS", "A server-side database backup file"],
    answer: "A small piece of data stored on the user's computer by the web browser while browsing a website"
  },
  {
    id: 444,
    question: "Which design pattern allows an object's behavior to be altered at runtime based on its state?",
    options: ["State pattern", "Singleton pattern", "Builder pattern", "Facade pattern"],
    answer: "State pattern"
  },
  {
    id: 445,
    question: "What does CDN stand for in web infrastructure?",
    options: ["Content Delivery Network", "Central Data Node", "Computer Distributed Network", "Core Domain Name"],
    answer: "Content Delivery Network"
  },
  {
    id: 446,
    question: "Which data structure is most efficient for implementing a LIFO structure?",
    options: ["Queue", "Stack", "Binary Tree", "Graph"],
    answer: "Stack"
  },
  {
    id: 447,
    question: "What is a compiler warning?",
    options: ["A fatal error that stops compilation immediately", "A message from the compiler indicating code that is valid but potentially suspicious or prone to bugs", "A notification that hardware is overheating", "A copyright notice from the library creator"],
    answer: "A message from the compiler indicating code that is valid but potentially suspicious or prone to bugs"
  },
  {
    id: 448,
    question: "Which networking device operates at the Network layer (Layer 3) and routes packets between networks?",
    options: ["Hub", "Switch", "Router", "Repeater"],
    answer: "Router"
  },
  {
    id: 449,
    question: "What is dynamic memory allocation?",
    options: ["Allocating memory at compile-time with fixed sizes", "Allocating memory storage during program runtime (e.g., using `malloc` or `new`)", "Automatically saving files to the cloud", "Caching browser images"],
    answer: "Allocating memory storage during program runtime (e.g., using `malloc` or `new`)"
  },
  {
    id: 450,
    question: "Which algorithmic strategy builds a solution piece by piece, always choosing the immediate next best option without looking ahead?",
    options: ["Dynamic programming", "Greedy algorithm", "Divide and conquer", "Backtracking"],
    answer: "Greedy algorithm"
  },
  {
    id: 451,
    question: "What does SaaS stand for in cloud computing?",
    options: ["Storage as a Service", "Software as a Service", "Security as a System", "Server as a Solution"],
    answer: "Software as a Service"
  },
  {
    id: 452,
    question: "Which tree traversal method visits the left subtree, then the root node, and finally the right subtree in a binary search tree to yield sorted order?",
    options: ["Pre-order traversal", "In-order traversal", "Post-order traversal", "Level-order traversal"],
    answer: "In-order traversal"
  },
  {
    id: 453,
    question: "What is an infinite loop?",
    options: ["A loop that executes exactly zero times", "A sequence of instructions that loops endlessly because the termination condition is never met", "A loop that runs faster than CPU clock speed", "A syntax error detected by the compiler"],
    answer: "A sequence of instructions that loops endlessly because the termination condition is never met"
  },
  {
    id: 454,
    question: "Which principle of the SOLID principles states that clients should not be forced to depend upon interfaces that they do not use?",
    options: ["Single Responsibility Principle", "Open-Closed Principle", "Interface Segregation Principle", "Dependency Inversion Principle"],
    answer: "Interface Segregation Principle"
  },
  {
    id: 455,
    question: "What is the primary function of an operating system's file manager?",
    options: ["Compile source code", "Organize, store, retrieve, and manage files and directories on storage devices", "Manage network routing protocols", "Render 3D graphics"],
    answer: "Organize, store, retrieve, and manage files and directories on storage devices"
  },
  {
    id: 456,
    question: "Which sorting algorithm uses a binary heap data structure to sort elements?",
    options: ["Merge sort", "Heap sort", "Quick sort", "Insertion sort"],
    answer: "Heap sort"
  },
  {
    id: 457,
    question: "What does the acronym ASCII stand for?",
    options: ["American Standard Code for Information Interchange", "Advanced System Code for Internet Integration", "Automated Sequence Character Information Index", "Application Standard Control Interface Code"],
    answer: "American Standard Code for Information Interchange"
  },
  {
    id: 458,
    question: "Which design pattern is a behavioral pattern that lets you pass requests along a chain of handlers?",
    options: ["Chain of Responsibility", "Singleton", "Adapter", "Proxy"],
    answer: "Chain of Responsibility"
  },
  {
    id: 459,
    question: "What is the time complexity of searching an element in a balanced binary search tree with n nodes?",
    options: ["O(1)", "O(log n)", "O(n)", "O(n log n)"],
    answer: "O(log n)"
  },
  {
    id: 460,
    question: "Which protocol secures communication over computer networks and is widely used for secure web browsing?",
    options: ["HTTP", "TLS / SSL", "FTP", "Telnet"],
    answer: "TLS / SSL"
  },
  {
    id: 461,
    question: "What is the role of a version control system like Git?",
    options: ["Scan code for syntax errors", "Track changes in source code during software development and coordinate work among multiple developers", "Deploy applications to AWS servers", "Optimize database indexing"],
    answer: "Track changes in source code during software development and coordinate work among multiple developers"
  },
  {
    id: 462,
    question: "Which data structure is typically used to implement recursion and function call history in programming language runtimes?",
    options: ["Queue", "Call Stack", "Hash Map", "Array List"],
    answer: "Call Stack"
  },
  {
    id: 463,
    question: "What does the term 'open-source license' specify?",
    options: ["How much users must pay to download software", "The terms and conditions under which users can use, modify, and distribute source code", "The exact hardware requirements to run software", "The network port configuration"],
    answer: "The terms and conditions under which users can use, modify, and distribute source code"
  },
  {
    id: 464,
    question: "Which algorithmic technique tries out multiple possibilities and backtracks when a choice leads to a dead end?",
    options: ["Greedy algorithm", "Backtracking", "Dynamic programming", "Binary search"],
    answer: "Backtracking"
  },
  {
    id: 465,
    question: "What is the purpose of unit testing in software development?",
    options: ["Test the entire system under heavy user load", "Verify that individual functions or methods work correctly in isolation", "Check user interface visual design", "Test database backup speeds"],
    answer: "Verify that individual functions or methods work correctly in isolation"
  },
  {
    id: 466,
    question: "Which protocol is used to retrieve emails from a mail server to a local client while keeping emails on the server by default?",
    options: ["POP3", "IMAP", "SMTP", "FTP"],
    answer: "IMAP"
  },
  {
    id: 467,
    question: "What is a foreign key in relational databases?",
    options: ["A key used to log into foreign servers", "A field (or collection of fields) in one table that uniquely identifies a row of another table", "An encrypted database password", "An index on foreign character sets"],
    answer: "A field (or collection of fields) in one table that uniquely identifies a row of another table"
  },
  {
    id: 468,
    question: "Which design pattern provides a unified interface to a set of interfaces in a subsystem, making the subsystem easier to use?",
    options: ["Facade pattern", "Singleton pattern", "Decorator pattern", "Observer pattern"],
    answer: "Facade pattern"
  },
  {
    id: 469,
    question: "What does the term 'scalability' mean in system design?",
    options: ["The physical weight of server racks", "The capability of a system to handle a growing amount of work by adding resources to the system", "The speed at which a compiler runs", "The ease of writing clean code"],
    answer: "The capability of a system to handle a growing amount of work by adding resources to the system"
  },
  {
    id: 470,
    question: "Which data structure represents a collection of nodes connected by edges, allowing cycles?",
    options: ["Tree", "Graph", "Queue", "Stack"],
    answer: "Graph"
  },
  {
    id: 471,
    question: "What is a memory leak in software applications?",
    options: ["Physical water damage to RAM sticks", "A failure in a program to release allocated memory that is no longer needed, leading to reduced performance or crashes", "Data corruption on solid state drives", "Slow network transfer rates"],
    answer: "A failure in a program to release allocated memory that is no longer needed, leading to reduced performance or crashes"
  },
  {
    id: 472,
    question: "Which cryptographic hash function produces a 128-bit hash value and is widely considered cryptographically broken for security use?",
    options: ["SHA-256", "MD5", "SHA-3", "bcrypt"],
    answer: "MD5"
  },
  {
    id: 473,
    question: "What is the main function of an operating system's device driver?",
    options: ["Translate instructions between the operating system and hardware devices", "Provide graphical user interfaces", "Compile high-level programming code", "Manage cloud server hosting"],
    answer: "Translate instructions between the operating system and hardware devices"
  },
  {
    id: 474,
    question: "Which software design principle advocates for keeping code simple and avoiding unnecessary complexity ('You Aren't Gonna Need It')?",
    options: ["DRY (Don't Repeat Yourself)", "YAGNI", "KISS (Keep It Simple, Stupid)", "SOLID"],
    answer: "YAGNI"
  },
  {
    id: 475,
    question: "What does the acronym CPU stand for?",
    options: ["Central Processing Unit", "Computer Program Utility", "Control Processing Unit", "Core Peripheral Unit"],
    answer: "Central Processing Unit"
  },
  {
    id: 476,
    question: "Which sorting algorithm works by repeatedly dividing the unsorted list into sublists until each sublist contains one element, then merging them?",
    options: ["Selection sort", "Merge sort", "Insertion sort", "Bubble sort"],
    answer: "Merge sort"
  },
  {
    id: 477,
    question: "What is a boolean variable?",
    options: ["A variable that stores floating-point numbers", "A variable that can hold only two possible values: true or false", "A variable that stores text strings", "A variable that points to memory addresses"],
    answer: "A variable that can hold only two possible values: true or false"
  },
  {
    id: 478,
    question: "Which principle of the SOLID principles states that software entities should be open for extension, but closed for modification?",
    options: ["Single Responsibility Principle", "Open-Closed Principle", "Liskov Substitution Principle", "Dependency Inversion Principle"],
    answer: "Open-Closed Principle"
  },
  {
    id: 479,
    question: "What is the function of a compiler optimizer?",
    options: ["Check spelling in source comments", "Transform code to improve efficiency, reduce execution time, or decrease memory usage without changing output", "Automatically deploy code to production", "Format code indentation"],
    answer: "Transform code to improve efficiency, reduce execution time, or decrease memory usage without changing output"
  },
  {
    id: 480,
    question: "Which database management system is classified as a NoSQL document database?",
    options: ["PostgreSQL", "MySQL", "MongoDB", "Oracle Database"],
    answer: "MongoDB"
  },
  {
    id: 481,
    question: "What is the time complexity of linear search on an unsorted array of size n?",
    options: ["O(1)", "O(log n)", "O(n)", "O(n log n)"],
    answer: "O(n)"
  },
  {
    id: 482,
    question: "Which network attack involves an attacker sending forged ARP messages over a local area network?",
    options: ["ARP spoofing (ARP poisoning)", "DNS spoofing", "SQL injection", "Cross-site scripting"],
    answer: "ARP spoofing (ARP poisoning)"
  },
  {
    id: 483,
    question: "What does HTML stand for?",
    options: ["HyperText Transfer Markup Language", "HyperText Markup Language", "High-Level Text Management Language", "Hyperlink Transfer Markup Level"],
    answer: "HyperText Markup Language"
  },
  {
    id: 484,
    question: "Which design pattern is used to dynamically add new behaviors to objects by placing them inside wrapper objects containing these behaviors?",
    options: ["Decorator pattern", "Singleton pattern", "Facade pattern", "Factory pattern"],
    answer: "Decorator pattern"
  },
  {
    id: 485,
    question: "What is the purpose of the `git commit` command?",
    options: ["Upload code to a remote GitHub repository", "Record changes to the local repository with a descriptive message", "Download updates from remote repositories", "Switch between different branches"],
    answer: "Record changes to the local repository with a descriptive message"
  },
  {
    id: 486,
    question: "Which data structure allows insertion and deletion at both ends efficiently?",
    options: ["Stack", "Queue", "Deque (Double-ended Queue)", "Priority Queue"],
    answer: "Deque (Double-ended Queue)"
  },
  {
    id: 487,
    question: "What is a runtime error?",
    options: ["An error detected by the compiler before running", "An error that occurs while a program is running, such as division by zero or running out of memory", "A hardware overheating issue", "A typo in variable naming"],
    answer: "An error that occurs while a program is running, such as division by zero or running out of memory"
  },
  {
    id: 488,
    question: "Which protocol is the foundation of data communication for the World Wide Web?",
    options: ["FTP", "HTTP", "SMTP", "SSH"],
    answer: "HTTP"
  },
  {
    id: 489,
    question: "What is object-oriented programming encapsulation?",
    options: ["Inheriting features from multiple parent classes", "Restricting direct access to some of an object's components and bundling methods that operate on the data into a single unit", "Creating multiple instances of a class", "Converting objects to binary streams"],
    answer: "Restricting direct access to some of an object's components and bundling methods that operate on the data into a single unit"
  },
  {
    id: 490,
    question: "Which graph traversal algorithm visits all reachable vertices using a stack (or recursion) by exploring as deep as possible?",
    options: ["Breadth-First Search (BFS)", "Depth-First Search (DFS)", "Dijkstra's Algorithm", "Prim's Algorithm"],
    answer: "Depth-First Search (DFS)"
  },
  {
    id: 491,
    question: "What does the term 'refactoring' aim to achieve?",
    options: ["Add brand new features to software", "Improve the non-functional attributes of software code, making it easier to read, maintain, and extend without changing external behavior", "Fix hardware motherboard faults", "Speed up network bandwidth"],
    answer: "Improve the non-functional attributes of software code, making it easier to read, maintain, and extend without changing external behavior"
  },
  {
    id: 492,
    question: "Which cloud service model provides complete infrastructure hardware including servers, storage, and networking?",
    options: ["SaaS", "PaaS", "IaaS", "FaaS"],
    answer: "IaaS"
  },
  {
    id: 493,
    question: "What is the primary function of a database management system (DBMS)?",
    options: ["Manage computer hardware drivers", "Provide a systematic way to create, retrieve, update, and manage data in databases securely", "Render 3D video games", "Translate high-level code to assembly"],
    answer: "Provide a systematic way to create, retrieve, update, and manage data in databases securely"
  },
  {
    id: 494,
    question: "Which sorting algorithm repeatedly compares adjacent elements and swaps them if they are in the wrong order?",
    options: ["Bubble sort", "Merge sort", "Quick sort", "Heap sort"],
    answer: "Bubble sort"
  },
  {
    id: 495,
    question: "What does API stand for?",
    options: ["Application Programming Interface", "Advanced Program Integration", "Automated Process Interaction", "Application Program Interchange"],
    answer: "Application Programming Interface"
  },
  {
    id: 496,
    question: "Which data structure uses LIFO (Last In, First Out) ordering?",
    options: ["Queue", "Stack", "Array", "Graph"],
    answer: "Stack"
  },
  {
    id: 497,
    question: "What is a hash collision in data structures?",
    options: ["Two computers trying to access the same Wi-Fi router", "When two distinct keys hash to the same index position in a hash table", "A memory overflow error", "A syntax clash between Python and Java"],
    answer: "When two distinct keys hash to the same index position in a hash table"
  },
  {
    id: 498,
    question: "Which protocol resolves IP addresses to MAC addresses on a local area network?",
    options: ["DNS", "ARP", "DHCP", "ICMP"],
    answer: "ARP"
  },
  {
    id: 499,
    question: "What is the time complexity of binary search on a sorted array of size n?",
    options: ["O(n)", "O(log n)", "O(1)", "O(n log n)"],
    answer: "O(log n)"
  },
  {
    id: 500,
    question: "What does the DRY principle stand for in software engineering?",
    options: ["Do Repeat Yourself", "Don't Repeat Yourself", "Deploy Regularly Yielding", "Data Record Yielding"],
    answer: "Don't Repeat Yourself"
  },
  {
    id: 501,
    question: "What is the dimensional formula of universal gravitational constant G?",
    options: ["[M^-1 L^3 T^-2]", "[M L^2 T^-2]", "[M^-1 L^2 T^-2]", "[M L^3 T^-2]"],
    answer: "[M^-1 L^3 T^-2]"
  },
  {
    id: 502,
    question: "If position of a particle depends on time as x = t^3 - 6t^2 + 9t, at what time is the velocity zero?",
    options: ["t = 1 s and t = 3 s", "t = 2 s only", "t = 0 s and t = 3 s", "t = 1 s and t = 2 s"],
    answer: "t = 1 s and t = 3 s"
  },
  {
    id: 503,
    question: "What is the value of the integral int (1 / (1 + x^2)) dx?",
    options: ["ln|1 + x^2| + C", "tan^-1(x) + C", "sin^-1(x) + C", "-cot^-1(x) + C"],
    answer: "tan^-1(x) + C"
  },
  {
    id: 504,
    question: "Which of the following molecules has a zero dipole moment?",
    options: ["H2O", "NH3", "BF3", "SO2"],
    answer: "BF3"
  },
  {
    id: 505,
    question: "What is the hybridization of the carbon atoms in an ethyne (acetylene) molecule?",
    options: ["sp3", "sp2", "sp", "sp3d"],
    answer: "sp"
  },
  {
    id: 506,
    question: "What is the de Broglie wavelength of an electron accelerated through a potential difference V?",
    options: ["h / sqrt(2meV)", "sqrt(2meV) / h", "h / (meV)", "h^2 / (2meV)"],
    answer: "h / sqrt(2meV)"
  },
  {
    id: 507,
    question: "For a complex number z, what is the value of z * conjugate(z)?",
    options: ["|z|", "|z|^2", "2|z|", "Real(z)"],
    answer: "|z|^2"
  },
  {
    id: 508,
    question: "What is the oxidation state of Chromium in K2Cr2O7?",
    options: ["+3", "+6", "+4", "+7"],
    answer: "+6"
  },
  {
    id: 509,
    question: "In simple harmonic motion, what is the phase difference between displacement and velocity?",
    options: ["0", "pi / 2", "pi", "3pi / 2"],
    answer: "pi / 2"
  },
  {
    id: 510,
    question: "What is the maximum number of electrons in an atom that can have the quantum numbers n = 4 and m_l = 0?",
    options: ["2", "6", "8", "14"],
    answer: "8"
  },
  {
    id: 511,
    question: "What is the derivative of x^x with respect to x?",
    options: ["x^x * ln(x)", "x * x^(x-1)", "x^x * (ln(x) + 1)", "x^x * x"],
    answer: "x^x * (ln(x) + 1)"
  },
  {
    id: 512,
    question: "Which of the following thermodynamics laws defines internal energy?",
    options: ["Zeroth Law", "First Law", "Second Law", "Third Law"],
    answer: "First Law"
  },
  {
    id: 513,
    question: "What is the IUPAC name of tertiary butyl chloride?",
    options: ["1-chloro-2-methylpropane", "2-chloro-2-methylpropane", "1-chlorobutane", "2-chlorobutane"],
    answer: "2-chloro-2-methylpropane"
  },
  {
    id: 514,
    question: "What is the escape velocity from the surface of Earth of mass M and radius R?",
    options: ["sqrt(GM / R)", "sqrt(2GM / R)", "GM / R", "sqrt(GM / 2R)"],
    answer: "sqrt(2GM / R)"
  },
  {
    id: 515,
    question: "If a matrix A is skew-symmetric, what is its determinant for an odd order matrix?",
    options: ["1", "-1", "0", "Depends on elements"],
    answer: "0"
  },
  {
    id: 516,
    question: "Which ore is concentrated by the froth floatation method?",
    options: ["Haematite", "Bauxite", "Zinc blende (Sphalerite)", "Magnetite"],
    answer: "Zinc blende (Sphalerite)"
  },
  {
    id: 517,
    question: "What is the unit of magnetic flux?",
    options: ["Tesla", "Weber", "Henry", "Ampere-meter"],
    answer: "Weber"
  },
  {
    id: 518,
    question: "What is the value of limit as x approaches 0 of (sin x) / x?",
    options: ["0", "1", "Infinity", "Undefined"],
    answer: "1"
  },
  {
    id: 519,
    question: "Which gas is evolved when dilute nitric acid reacts with active metals like magnesium?",
    options: ["Hydrogen", "Nitrogen dioxide", "Nitric oxide", "Nitrous oxide"],
    answer: "Hydrogen"
  },
  {
    id: 520,
    question: "What is the focal length of a plane mirror?",
    options: ["Zero", "Infinity", "Positive", "Negative"],
    answer: "Infinity"
  },
  {
    id: 521,
    question: "What is the number of all possible matrices of order 3 x 3 with each entry 0 or 1?",
    options: ["27", "512", "81", "18"],
    answer: "512"
  },
  {
    id: 522,
    question: "Which transition metal complex shows optical isomerism?",
    options: ["[Co(NH3)6]^3+", "[Co(en)3]^3+", "[PtCl4]^2-", "[Ni(CN)4]^2-"],
    answer: "[Co(en)3]^3+"
  },
  {
    id: 523,
    question: "What is the root mean square velocity of gas molecules directly proportional to?",
    options: ["Absolute temperature (T)", "Square root of absolute temperature (sqrt(T))", "Pressure (P)", "Molar mass (M)"],
    answer: "Square root of absolute temperature (sqrt(T))"
  },
  {
    id: 524,
    question: "What is the principal value of sin^-1(-1/2)?",
    options: ["pi / 6", "-pi / 6", "5pi / 6", "-5pi / 6"],
    answer: "-pi / 6"
  },
  {
    id: 525,
    question: "Which element among the halogens has the highest electron gain enthalpy (most negative)?",
    options: ["Fluorine", "Chlorine", "Bromine", "Iodine"],
    answer: "Chlorine"
  },
  {
    id: 526,
    question: "What is the angular momentum of an electron in the 3rd Bohr orbit?",
    options: ["3h / (2pi)", "h / (2pi)", "6h / (2pi)", "1.5h / (2pi)"],
    answer: "3h / (2pi)"
  },
  {
    id: 527,
    question: "What is the sum of coefficients in the binomial expansion of (1 + x)^n?",
    options: ["2^n", "2^(n-1)", "n^2", "1"],
    answer: "2^n"
  },
  {
    id: 528,
    question: "Which polymer is formed by the condensation polymerization of hexamethylenediamine and adipic acid?",
    options: ["Terylene", "Nylon 6,6", "Bakelite", "Neoprene"],
    answer: "Nylon 6,6"
  },
  {
    id: 529,
    question: "What is the work done in moving a charge along an equipotential surface?",
    options: ["Maximum", "Zero", "Positive", "Negative"],
    answer: "Zero"
  },
  {
    id: 530,
    question: "What is the general solution of the differential equation dy/dx = y / x?",
    options: ["y = cx", "y = c / x", "xy = c", "y = c + x"],
    answer: "y = cx"
  },
  {
    id: 531,
    question: "Which catalyst is used in the Haber process for the manufacture of ammonia?",
    options: ["Finely divided Iron with Mo promoter", "Nickel", "Platinized asbestos", "V2O5"],
    answer: "Finely divided Iron with Mo promoter"
  },
  {
    id: 532,
    question: "What is the threshold frequency of a metal dependent on?",
    options: ["Intensity of incident light", "Frequency of incident light", "Nature of the metal surface", "Distance from source"],
    answer: "Nature of the metal surface"
  },
  {
    id: 533,
    question: "What is the eccentricity of a rectangular hyperbola?",
    options: ["1", "sqrt(2)", "2", "sqrt(3)"],
    answer: "sqrt(2)"
  },
  {
    id: 534,
    question: "Which vitamin deficiency causes scurvy?",
    options: ["Vitamin A", "Vitamin B1", "Vitamin C", "Vitamin D"],
    answer: "Vitamin C"
  },
  {
    id: 535,
    question: "What is the SI unit of electric dipole moment?",
    options: ["Coulomb-meter", "Volt/meter", "Newton/Coulomb", "Farad"],
    answer: "Coulomb-meter"
  },
  {
    id: 536,
    question: "If vectors a, b, and c are coplanar, what is their scalar triple product [a b c] equal to?",
    options: ["1", "-1", "0", "Magnitude of vectors"],
    answer: "0"
  },
  {
    id: 537,
    question: "Which noble gas is most abundant in Earth's atmosphere?",
    options: ["Helium", "Neon", "Argon", "Krypton"],
    answer: "Argon"
  },
  {
    id: 538,
    question: "What happens to the capacitance of a parallel plate capacitor when a dielectric slab is introduced between its plates?",
    options: ["Decreases", "Increases", "Remains constant", "Becomes zero"],
    answer: "Increases"
  },
  {
    id: 539,
    question: "What is the value of int (e^x * (f(x) + f'(x))) dx?",
    options: ["e^x * f(x) + C", "e^x / f(x) + C", "f(x) + C", "e^x * f'(x) + C"],
    answer: "e^x * f(x) + C"
  },
  {
    id: 540,
    question: "What is the main product of the reaction between phenol and dilute nitric acid at low temperature?",
    options: ["Picric acid", "Mixture of o- and p-nitrophenol", "m-nitrophenol", "Benzoic acid"],
    answer: "Mixture of o- and p-nitrophenol"
  },
  {
    id: 541,
    question: "What is the self-inductance of a coil dependent on?",
    options: ["Current flowing through it", "Rate of change of current", "Geometrical features of the coil", "Voltage applied across it"],
    answer: "Geometrical features of the coil"
  },
  {
    id: 542,
    question: "What is the domain of the function f(x) = sqrt(1 - x^2)?",
    options: ["(-inf, inf)", "[-1, 1]", "(0, 1)", "[0, inf)"],
    answer: "[-1, 1]"
  },
  {
    id: 543,
    question: "Which of the following compounds gives a positive iodoform test?",
    options: ["Ethanol", "Methanol", "Propan-1-ol", "Phenol"],
    answer: "Ethanol"
  },
  {
    id: 544,
    question: "What is the angle of dip at the magnetic poles of the Earth?",
    options: ["0 degrees", "45 degrees", "90 degrees", "180 degrees"],
    answer: "90 degrees"
  },
  {
    id: 545,
    question: "What is the coefficient of x^n in the expansion of (1 - x)^(-1)?",
    options: ["-1", "1", "(-1)^n", "n"],
    answer: "1"
  },
  {
    id: 546,
    question: "What is the geometry of the CIF3 molecule according to VSEPR theory?",
    options: ["T-shaped", "Trigonal planar", "Tetrahedral", "Octahedral"],
    answer: "T-shaped"
  },
  {
    id: 547,
    question: "What is the dimensional formula of Planck's constant h?",
    options: ["[M L^2 T^-1]", "[M L^2 T^-2]", "[M L T^-1]", "[M^-1 L^2 T^-2]"],
    answer: "[M L^2 T^-1]"
  },
  {
    id: 548,
    question: "If A and B are two independent events, what is P(A intersection B)?",
    options: ["P(A) + P(B)", "P(A) * P(B)", "P(A) / P(B)", "Zero"],
    answer: "P(A) * P(B)"
  },
  {
    id: 549,
    question: "Which acid is present in vinegar?",
    options: ["Formic acid", "Acetic acid", "Citric acid", "Oxalic acid"],
    answer: "Acetic acid"
  },
  {
    id: 550,
    question: "What is the energy of a photon of wavelength lambda?",
    options: ["hc / lambda", "h * lambda / c", "lambda / hc", "hc * lambda"],
    answer: "hc / lambda"
  },
  {
    id: 551,
    question: "What is the maximum value of the function sin(x) + cos(x)?",
    options: ["1", "sqrt(2)", "2", "1 / sqrt(2)"],
    answer: "sqrt(2)"
  },
  {
    id: 552,
    question: "Which element has the highest electronegativity in the periodic table?",
    options: ["Chlorine", "Oxygen", "Fluorine", "Nitrogen"],
    answer: "Fluorine"
  },
  {
    id: 553,
    question: "What is the moment of inertia of a solid sphere of mass M and radius R about its diameter?",
    options: ["(2/5)MR^2", "(2/3)MR^2", "(1/2)MR^2", "(7/5)MR^2"],
    answer: "(2/5)MR^2"
  },
  {
    id: 554,
    question: "What is the inverse of the matrix [[1, 2], [3, 4]]?",
    options: ["[[-2, 1], [1.5, -0.5]]", "[[1, 2], [3, 4]]", "[[-4, 2], [3, -1]] / 2", "Does not exist"],
    answer: "[[-2, 1], [1.5, -0.5]]"
  },
  {
    id: 555,
    question: "Which reagent is used in the Clemmensen reduction of carbonyl compounds?",
    options: ["Zn-Hg / conc. HCl", "NH2NH2 / KOH", "LiAlH4", "H2 / Pd-BaSO4"],
    answer: "Zn-Hg / conc. HCl"
  },
  {
    id: 556,
    question: "What is the refractive index of a medium if the polarizing angle is 60 degrees?",
    options: ["1", "sqrt(3)", "1 / sqrt(3)", "2"],
    answer: "sqrt(3)"
  },
  {
    id: 557,
    question: "What is the value of i^i (where i = sqrt(-1))?",
    options: ["e^(-pi/2)", "i", "-1", "1"],
    answer: "e^(-pi/2)"
  },
  {
    id: 558,
    question: "Which of the following is an intensive property?",
    options: ["Enthalpy", "Mass", "Temperature", "Volume"],
    answer: "Temperature"
  },
  {
    id: 559,
    question: "What is the terminal velocity of a small sphere falling through a viscous fluid proportional to?",
    options: ["Radius of sphere (r)", "Square of radius of sphere (r^2)", "Square root of radius (sqrt(r))", "Inverse of radius (1/r)"],
    answer: "Square of radius of sphere (r^2)"
  },
  {
    id: 560,
    question: "What is the derivative of tan^-1(x) with respect to x?",
    options: ["1 / (1 + x^2)", "-1 / (1 + x^2)", "1 / sqrt(1 - x^2)", "sec^2(x)"],
    answer: "1 / (1 + x^2)"
  },
  {
    id: 561,
    question: "Which complex salt is used in chemotherapy for cancer treatment?",
    options: ["Cisplatin", "Zeise's salt", "Potassium ferrocyanide", "Sodium nitroprusside"],
    answer: "Cisplatin"
  },
  {
    id: 562,
    question: "What is the efficiency of a Carnot engine operating between temperatures T1 (source) and T2 (sink)?",
    options: ["1 - (T2 / T1)", "1 - (T1 / T2)", "T2 / T1", "(T1 - T2) / T2"],
    answer: "1 - (T2 / T1)"
  },
  {
    id: 563,
    question: "If a line makes angles alpha, beta, gamma with the coordinate axes, what is sin^2(alpha) + sin^2(beta) + sin^2(gamma) equal to?",
    options: ["1", "2", "3", "0"],
    answer: "2"
  },
  {
    id: 564,
    question: "Which block of the periodic table contains inner transition elements?",
    options: ["s-block", "p-block", "d-block", "f-block"],
    answer: "f-block"
  },
  {
    id: 565,
    question: "What is the dimensional formula for surface tension?",
    options: ["[M L T^-2]", "[M L^0 T^-2]", "[M L^-1 T^-2]", "[M L^2 T^-2]"],
    answer: "[M L^0 T^-2]"
  },
  {
    id: 566,
    question: "What is the sum of the roots of the quadratic equation ax^2 + bx + c = 0?",
    options: ["c / a", "-b / a", "b / a", "-c / a"],
    answer: "-b / a"
  },
  {
    id: 567,
    question: "Which substance is added to rubber during vulcanization?",
    options: ["Carbon", "Sulfur", "Phosphorus", "Nitrogen"],
    answer: "Sulfur"
  },
  {
    id: 568,
    question: "What happens to the fringe width in Young's double-slit experiment if the distance between slits is doubled?",
    options: ["Doubled", "Halved", "Remains same", "Quadrupled"],
    answer: "Halved"
  },
  {
    id: 569,
    question: "What is the value of int (x * e^x) dx?",
    options: ["e^x * (x - 1) + C", "e^x * (x + 1) + C", "x * e^x + C", "e^x / x + C"],
    answer: "e^x * (x - 1) + C"
  },
  {
    id: 570,
    question: "Which of the following is a condensation polymer?",
    options: ["Polythene", "PVC", "Nylon 6,6", "Buna-S"],
    answer: "Nylon 6,6"
  },
  {
    id: 571,
    question: "What is the unit of magnetic dipole moment?",
    options: ["Ampere-meter^2", "Weber / meter", "Tesla-meter", "Coulomb-meter"],
    answer: "Ampere-meter^2"
  },
  {
    id: 572,
    question: "If f(x) = x^3, what is the value of the derivative at x = 2?",
    options: ["6", "8", "12", "24"],
    answer: "12"
  },
  {
    id: 573,
    question: "Which of the following is an example of an ambidentate ligand?",
    options: ["NH3", "H2O", "NO2^-", "Cl^-"],
    answer: "NO2^-"
  },
  {
    id: 574,
    question: "What is the relationship between radius of curvature R and focal length f of a spherical mirror?",
    options: ["R = f", "R = 2f", "f = 2R", "R = f / 2"],
    answer: "R = 2f"
  },
  {
    id: 575,
    question: "What is the modulus of the complex number 3 + 4i?",
    options: ["3", "4", "5", "7"],
    answer: "5"
  },
  {
    id: 576,
    question: "Which halogen is a liquid at room temperature?",
    options: ["Fluorine", "Chlorine", "Bromine", "Iodine"],
    answer: "Bromine"
  },
  {
    id: 577,
    question: "What is the rms speed of gas molecules proportional to in terms of molar mass M?",
    options: ["M", "1 / M", "1 / sqrt(M)", "sqrt(M)"],
    answer: "1 / sqrt(M)"
  },
  {
    id: 578,
    question: "What is the integral of tan(x) dx?",
    options: ["ln|sec(x)| + C", "-ln|cos(x)| + C", "sec^2(x) + C", "Both A and B"],
    answer: "Both A and B"
  },
  {
    id: 579,
    question: "Which metal is extracted via self-reduction in a bessemer converter?",
    options: ["Copper", "Iron", "Aluminum", "Zinc"],
    answer: "Copper"
  },
  {
    id: 580,
    question: "What is the energy stored in an inductor of inductance L carrying current I?",
    options: ["(1/2)LI", "(1/2)LI^2", "LI^2", "L^2 I"],
    answer: "(1/2)LI^2"
  },
  {
    id: 581,
    question: "What is the argument of the complex number -1 - i?",
    options: ["-pi / 4", "-3pi / 4", "pi / 4", "3pi / 4"],
    answer: "-3pi / 4"
  },
  {
    id: 582,
    question: "Which element does not form hydrogen bonds?",
    options: ["Fluorine", "Oxygen", "Nitrogen", "Chlorine"],
    answer: "Chlorine"
  },
  {
    id: 583,
    question: "What is the acceleration due to gravity at a height equal to the radius of Earth (R)?",
    options: ["g / 2", "g / 4", "g / 9", "g / 3"],
    answer: "g / 4"
  },
  {
    id: 584,
    question: "What is the rank of a zero matrix?",
    options: ["0", "1", "Not defined", "Equal to its order"],
    answer: "0"
  },
  {
    id: 585,
    question: "What is the primary product when ethyl alcohol is heated with excess conc. H2SO4 at 443 K?",
    options: ["Diethyl ether", "Ethylene (Ethene)", "Ethane", "Ethyl hydrogensulfate"],
    answer: "Ethylene (Ethene)"
  },
  {
    id: 586,
    question: "What is the critical angle for total internal reflection dependent on?",
    options: ["Wavelength of light", "Refractive indices of the two media", "Both A and B", "Intensity of incident light"],
    answer: "Both A and B"
  },
  {
    id: 587,
    question: "What is the sum of coefficients of odd powers of x in the expansion of (1 + x)^n?",
    options: ["2^n", "2^(n-1)", "0", "2^(n-2)"],
    answer: "2^(n-1)"
  },
  {
    id: 588,
    question: "Which ore of iron has the highest percentage of iron?",
    options: ["Haematite", "Magnetite", "Siderite", "Iron pyrite"],
    answer: "Magnetite"
  },
  {
    id: 589,
    question: "What is the time period of a simple pendulum inside a satellite orbiting the Earth?",
    options: ["Zero", "Infinite", "2 seconds", "Depends on mass"],
    answer: "Infinite"
  },
  {
    id: 590,
    question: "If vectors A and B are perpendicular to each other, what is their dot product?",
    options: ["1", "-1", "0", "Magnitude of A * B"],
    answer: "0"
  },
  {
    id: 591,
    question: "Which gas is released when calcium carbide reacts with water?",
    options: ["Methane", "Ethyne (Acetylene)", "Ethene", "Ethane"],
    answer: "Ethyne (Acetylene)"
  },
  {
    id: 592,
    question: "What is the phase relationship between current and voltage in a purely capacitive AC circuit?",
    options: ["Voltage leads current by pi/2", "Current leads voltage by pi/2", "In phase", "Current leads voltage by pi"],
    answer: "Current leads voltage by pi/2"
  },
  {
    id: 593,
    question: "What is the derivative of a constant function with respect to x?",
    options: ["1", "-1", "0", "Constant itself"],
    answer: "0"
  },
  {
    id: 594,
    question: "Which of the following compounds is most acidic?",
    options: ["Ethanol", "Water", "Phenol", "Acetic acid"],
    answer: "Acetic acid"
  },
  {
    id: 595,
    question: "What is the dimensional formula of torque?",
    options: ["[M L T^-2]", "[M L^2 T^-2]", "[M L^-1 T^-2]", "[M L^2 T^-1]"],
    answer: "[M L^2 T^-2]"
  },
  {
    id: 596,
    question: "What is the value of C(n, r) + C(n, r-1)?",
    options: ["C(n+1, r)", "C(n, r+1)", "C(n-1, r)", "C(n+1, r-1)"],
    answer: "C(n+1, r)"
  },
  {
    id: 597,
    question: "Which noble gas is radioactive?",
    options: ["Xenon", "Radon", "Krypton", "Argon"],
    answer: "Radon"
  },
  {
    id: 598,
    question: "What is the SI unit of magnetic induction (magnetic field strength B)?",
    options: ["Weber", "Tesla", "Henry", "Gauss"],
    answer: "Tesla"
  },
  {
    id: 599,
    question: "What is the eccentricity of a parabola?",
    options: ["0", "1", "Between 0 and 1", "Greater than 1"],
    answer: "1"
  },
  {
    id: 600,
    question: "Which catalyst is used in the Friedel-Crafts alkylation of benzene?",
    options: ["Anhydrous AlCl3", "Conc. H2SO4", "FeCl3", "ZnCl2"],
    answer: "Anhydrous AlCl3"
  },
  {
    id: 601,
    question: "What is the moment of inertia of a uniform circular ring of mass M and radius R about a transverse axis passing through its center?",
    options: ["MR^2", "(1/2)MR^2", "(2/3)MR^2", "(1/4)MR^2"],
    answer: "MR^2"
  },
  {
    id: 602,
    question: "What is the value of limit as x approaches 0 of (e^x - 1) / x?",
    options: ["0", "1", "e", "Infinity"],
    answer: "1"
  },
  {
    id: 603,
    question: "Which gas is evolved during the reaction of concentrated sulfuric acid with sodium chloride?",
    options: ["Cl2", "HCl", "SO2", "H2S"],
    answer: "HCl"
  },
  {
    id: 604,
    question: "What is the color of the central fringe in an interference pattern?",
    options: ["Dark", "Bright", "Colored", "Depends on wavelength"],
    answer: "Bright"
  },
  {
    id: 605,
    question: "If a matrix is both symmetric and skew-symmetric, what type of matrix must it be?",
    options: ["Identity matrix", "Zero matrix", "Diagonal matrix", "Scalar matrix"],
    answer: "Zero matrix"
  },
  {
    id: 606,
    question: "Which compound is known as oil of wintergreen?",
    options: ["Methyl salicylate", "Phenyl benzoate", "Benzyl acetate", "Salicylic acid"],
    answer: "Methyl salicylate"
  },
  {
    id: 607,
    question: "What is the work done in an isothermal expansion of an ideal gas?",
    options: ["nRT ln(V2/V1)", "Zero", "Cv * (T2 - T1)", "nCp * (T2 - T1)"],
    answer: "nRT ln(V2/V1)"
  },
  {
    id: 608,
    question: "What is the integral of sec^2(x) dx?",
    options: ["tan(x) + C", "-cot(x) + C", "sec(x) + C", "-csc(x) + C"],
    answer: "tan(x) + C"
  },
  {
    id: 609,
    question: "Which element is used as a semiconductor in computer chips?",
    options: ["Copper", "Silicon", "Iron", "Gold"],
    answer: "Silicon"
  },
  {
    id: 610,
    question: "What is the frequency of AC mains electricity in India?",
    options: ["50 Hz", "60 Hz", "100 Hz", "120 Hz"],
    answer: "50 Hz"
  },
  {
    id: 611,
    question: "What is the range of the function f(x) = sin^-1(x)?",
    options: ["[-1, 1]", "[-pi/2, pi/2]", "(0, pi)", "[0, pi]"],
    answer: "[-pi/2, pi/2]"
  },
  {
    id: 612,
    question: "Which of the following oxoacids of chlorine is the strongest acid?",
    options: ["HClO", "HClO2", "HClO3", "HClO4"],
    answer: "HClO4"
  },
  {
    id: 613,
    question: "What is the angular speed of Earth's rotation about its polar axis?",
    options: ["7.27 x 10^-5 rad/s", "3.14 x 10^-4 rad/s", "1.57 x 10^-3 rad/s", "9.81 rad/s"],
    answer: "7.27 x 10^-5 rad/s"
  },
  {
    id: 614,
    question: "What is the value of the determinant of a diagonal matrix equal to?",
    options: ["Sum of diagonal elements", "Product of diagonal elements", "Zero", "One"],
    answer: "Product of diagonal elements"
  },
  {
    id: 615,
    question: "Which functional group is present in carbohydrates as reducing sugars?",
    options: ["Aldehyde or Ketone group", "Carboxyl group", "Ester group", "Ether group"],
    answer: "Aldehyde or Ketone group"
  },
  {
    id: 616,
    question: "What is the unit of self-inductance?",
    options: ["Weber", "Tesla", "Henry", "Farad"],
    answer: "Henry"
  },
  {
    id: 617,
    question: "If roots of equation x^2 + px + q = 0 are tan(30) and tan(15), what is the value of 2 + p - q?",
    options: ["0", "1", "2", "3"],
    answer: "3"
  },
  {
    id: 618,
    question: "Which metal does not liberate hydrogen with dilute acids?",
    options: ["Zinc", "Copper", "Iron", "Magnesium"],
    answer: "Copper"
  },
  {
    id: 619,
    question: "What is the ratio of root mean square velocity to average velocity of gas molecules?",
    options: ["sqrt(3/8) : 1", "sqrt(3/pi) : 1", "sqrt(8/3pi) : 1", "1 : sqrt(3/pi)"],
    answer: "sqrt(3/pi) : 1"
  },
  {
    id: 620,
    question: "What is the derivative of a^x with respect to x?",
    options: ["a^x * ln(a)", "x * a^(x-1)", "a^x / ln(a)", "a^x"],
    answer: "a^x * ln(a)"
  },
  {
    id: 621,
    question: "Which transition element shows maximum number of oxidation states?",
    options: ["Iron", "Manganese", "Chromium", "Titanium"],
    answer: "Manganese"
  },
  {
    id: 622,
    question: "What is the path difference corresponding to a phase difference of 2pi radians?",
    options: ["lambda / 2", "lambda", "2lambda", "lambda / 4"],
    answer: "lambda"
  },
  {
    id: 623,
    question: "What is the eccentricity of an ellipse whose foci are at distance 2c and major axis length 2a?",
    options: ["a / c", "c / a", "a^2 / c^2", "c^2 / a^2"],
    answer: "c / a"
  },
  {
    id: 624,
    question: "Which compound is formed when benzaldehyde reacts with concentrated NaOH (Cannizzaro reaction)?",
    options: ["Benzyl alcohol and Sodium benzoate", "Benzoic acid", "Toluene", "Phenol"],
    answer: "Benzyl alcohol and Sodium benzoate"
  },
  {
    id: 625,
    question: "What is the dimensional formula of electric resistance?",
    options: ["[M L^2 T^-3 A^-2]", "[M L^2 T^-2 A^-1]", "[M^-1 L^-2 T^3 A^2]", "[M L^3 T^-3 A^-2]"],
    answer: "[M L^2 T^-3 A^-2]"
  },
  {
    id: 626,
    question: "What is the sum of an infinite geometric progression with first term a and common ratio r (|r| < 1)?",
    options: ["a / (1 - r)", "a / (1 + r)", "a * (1 - r)", "a / r"],
    answer: "a / (1 - r)"
  },
  {
    id: 627,
    question: "Which element is a liquid at room temperature among the transition metals?",
    options: ["Gallium", "Mercury", "Cesium", "Bromine"],
    answer: "Mercury"
  },
  {
    id: 628,
    question: "What is the force acting on a moving charge q in a magnetic field B with velocity v?",
    options: ["q(v x B)", "q(E + v x B)", "qvB", "q(B x v)"],
    answer: "q(v x B)"
  },
  {
    id: 629,
    question: "What is the integral of 1 / sqrt(a^2 - x^2) dx?",
    options: ["sin^-1(x / a) + C", "cos^-1(x / a) + C", "ln|x + sqrt(x^2 - a^2)| + C", "1/a * tan^-1(x/a) + C"],
    answer: "sin^-1(x / a) + C"
  },
  {
    id: 630,
    question: "Which polymer is known by the trade name Orlon?",
    options: ["Polyacrylonitrile", "Polystyrene", "PVC", "Teflon"],
    answer: "Polyacrylonitrile"
  },
  {
    id: 631,
    question: "What is the SI unit of electric potential?",
    options: ["Joule", "Volt", "Ampere", "Coulomb"],
    answer: "Volt"
  },
  {
    id: 632,
    question: "If A is a square matrix of order 3 and det(A) = 5, what is det(2A)?",
    options: ["10", "20", "40", "15"],
    answer: "40"
  },
  {
    id: 633,
    question: "Which gas is produced when zinc reacts with dilute hydrochloric acid?",
    options: ["Chlorine", "Hydrogen", "Oxygen", "Hydrogen chloride"],
    answer: "Hydrogen"
  },
  {
    id: 634,
    question: "What is the work done in stretching a spring by distance x with spring constant k?",
    options: ["kx", "(1/2)kx^2", "kx^2", "(1/3)kx^3"],
    answer: "(1/2)kx^2"
  },
  {
    id: 635,
    question: "What is the value of limit as x approaches 0 of (ln(1 + x)) / x?",
    options: ["0", "1", "e", "Infinity"],
    answer: "1"
  },
  {
    id: 636,
    question: "Which ore is concentrated by magnetic separation?",
    options: ["Haematite", "Magnetite", "Pyrolusite", "Chromite"],
    answer: "Magnetite"
  },
  {
    id: 637,
    question: "What is the power factor of a purely inductive AC circuit?",
    options: ["0", "1", "0.5", "Infinity"],
    answer: "0"
  },
  {
    id: 638,
    question: "What is the argument of a pure positive real number?",
    options: ["0", "pi / 2", "pi", "3pi / 2"],
    answer: "0"
  },
  {
    id: 639,
    question: "Which of the following compounds has a pyramidal shape?",
    options: ["BF3", "NH3", "CH4", "CO2"],
    answer: "NH3"
  },
  {
    id: 640,
    question: "What is the dimensional formula of universal gas constant R?",
    options: ["[M L^2 T^-2 K^-1 mol^-1]", "[M L^2 T^-1 K^-1]", "[M L T^-2 K^-1]", "[M^-1 L^2 T^-2 K^-1]"],
    answer: "[M L^2 T^-2 K^-1 mol^-1]"
  },
  {
    id: 641,
    question: "What is the general solution of the differential equation d^2y/dx^2 + y = 0?",
    options: ["y = A cos(x) + B sin(x)", "y = A e^x + B e^-x", "y = A x + B", "y = A sin(x)"],
    answer: "y = A cos(x) + B sin(x)"
  },
  {
    id: 642,
    question: "Which transition metal ion is colorless in aqueous solution?",
    options: ["Ti^3+", "V^3+", "Sc^3+", "Ni^2+"],
    answer: "Sc^3+"
  },
  {
    id: 643,
    question: "What is the velocity of electromagnetic waves in vacuum?",
    options: ["c = 1 / sqrt(mu_0 * epsilon_0)", "c = sqrt(mu_0 * epsilon_0)", "c = mu_0 * epsilon_0", "c = mu_0 / epsilon_0"],
    answer: "c = 1 / sqrt(mu_0 * epsilon_0)"
  },
  {
    id: 644,
    question: "What is the value of int from -a to a of f(x) dx when f(x) is an odd function?",
    options: ["2 * int from 0 to a of f(x) dx", "0", "int from 0 to a of f(x) dx", "a"],
    answer: "0"
  },
  {
    id: 645,
    question: "Which allotrope of carbon is a good conductor of electricity?",
    options: ["Diamond", "Graphite", "Fullerene", "Coal"],
    answer: "Graphite"
  },
  {
    id: 646,
    question: "What is the angular frequency of LC oscillations?",
    options: ["1 / sqrt(LC)", "sqrt(LC)", "L / C", "C / L"],
    answer: "1 / sqrt(LC)"
  },
  {
    id: 647,
    question: "What is the number of tangents that can be drawn from an external point to a circle?",
    options: ["1", "2", "Infinite", "0"],
    answer: "2"
  },
  {
    id: 648,
    question: "Which reagent converts primary alcohols directly to carboxylic acids?",
    options: ["PCC", "KMnO4 in acidic medium", "Cu at 573 K", "LiAlH4"],
    answer: "KMnO4 in acidic medium"
  },
  {
    id: 649,
    question: "What is the kinetic energy of a rolling body of mass M, radius R, radius of gyration K, and linear velocity v?",
    options: ["(1/2)Mv^2", "(1/2)Mv^2 * (1 + K^2/R^2)", "(1/2)Mv^2 * (K^2/R^2)", "Mv^2 * (1 + K^2/R^2)"],
    answer: "(1/2)Mv^2 * (1 + K^2/R^2)"
  },
  {
    id: 650,
    question: "What is the derivative of sin(x) with respect to cos(x)?",
    options: ["-cot(x)", "tan(x)", "-tan(x)", "cot(x)"],
    answer: "-cot(x)"
  },
  {
    id: 651,
    question: "Which group of elements is known as the chalcogens?",
    options: ["Group 15", "Group 16", "Group 17", "Group 18"],
    answer: "Group 16"
  },
  {
    id: 652,
    question: "What is the unit of mutual inductance?",
    options: ["Tesla", "Weber", "Henry", "Farad"],
    answer: "Henry"
  },
  {
    id: 653,
    question: "If lines ax + by + c = 0 and dx + ey + f = 0 are perpendicular, what is the relation between coefficients?",
    options: ["ad - be = 0", "ae + bd = 0", "ab + de = 0", "a/d = b/e"],
    answer: "ae + bd = 0"
  },
  {
    id: 654,
    question: "Which compound is formed by the reaction of Grignard reagent with carbon dioxide followed by hydrolysis?",
    options: ["Primary alcohol", "Secondary alcohol", "Carboxylic acid", "Ketone"],
    answer: "Carboxylic acid"
  },
  {
    id: 655,
    question: "What is the SI unit of Stefan-Boltzmann constant?",
    options: ["W m^-2 K^-4", "J m^-2 K^-1", "W m^-1 K^-1", "J s^-1 m^-2"],
    answer: "W m^-2 K^-4"
  },
  {
    id: 656,
    question: "What is the value of C(n, 0) + C(n, 1) + C(n, 2) + ... + C(n, n)?",
    options: ["n^2", "2^n", "2^(n-1)", "n!"],
    answer: "2^n"
  },
  {
    id: 657,
    question: "Which metal is refined via the Mond process?",
    options: ["Nickel", "Zirconium", "Titanium", "Copper"],
    answer: "Nickel"
  },
  {
    id: 658,
    question: "What is the magnetic field at the center of a circular coil of radius R carrying current I with N turns?",
    options: ["mu_0 N I / (2R)", "mu_0 N I / R", "2 mu_0 N I / R", "mu_0 N I / (4R)"],
    answer: "mu_0 N I / (2R)"
  },
  {
    id: 659,
    question: "What is the integral of 1 / (x^2 + a^2) dx?",
    options: ["1/a * tan^-1(x/a) + C", "ln|x^2 + a^2| + C", "sin^-1(x/a) + C", "1/a * ln|(x-a)/(x+a)| + C"],
    answer: "1/a * tan^-1(x/a) + C"
  },
  {
    id: 660,
    question: "Which of the following elements has the lowest first ionization enthalpy?",
    options: ["Lithium", "Sodium", "Cesium", "Potassium"],
    answer: "Cesium"
  },
  {
    id: 661,
    question: "What is the unit of magnetic susceptibility?",
    options: ["Tesla-meter", "Weber", "Dimensionless", "Henry/meter"],
    answer: "Dimensionless"
  },
  {
    id: 662,
    question: "If a and b are unit vectors and the angle between them is theta, what is |a - b|?",
    options: ["2 sin(theta / 2)", "2 cos(theta / 2)", "sin(theta)", "cos(theta)"],
    answer: "2 sin(theta / 2)"
  },
  {
    id: 663,
    question: "Which acid is used in lead storage batteries?",
    options: ["HCl", "HNO3", "H2SO4", "H3PO4"],
    answer: "H2SO4"
  },
  {
    id: 664,
    question: "What is the dimensional formula of electric permittivity of free space (epsilon_0)?",
    options: ["[M^-1 L^-3 T^4 A^2]", "[M L^3 T^-4 A^-2]", "[M^-1 L^-2 T^2 A]", "[M L^2 T^-2 A^2]"],
    answer: "[M^-1 L^-3 T^4 A^2]"
  },
  {
    id: 665,
    question: "What is the maximum number of points of intersection of two circles?",
    options: ["1", "2", "4", "Infinite"],
    answer: "2"
  },
  {
    id: 666,
    question: "Which metal is used in the Van Arkel method for ultra-purification of Zirconium?",
    options: ["Iodine", "Chlorine", "Fluorine", "Bromine"],
    answer: "Iodine"
  },
  {
    id: 667,
    question: "What is the speed of sound in an ideal gas proportional to in terms of temperature T?",
    options: ["T", "sqrt(T)", "1 / T", "1 / sqrt(T)"],
    answer: "sqrt(T)"
  },
  {
    id: 668,
    question: "What is the value of int from 0 to pi/2 of sin^n(x) dx when n is an odd integer?",
    options: ["[(n-1)(n-3)...2] / [n(n-2)...1] * (pi/2)", "[(n-1)(n-3)...2] / [n(n-2)...3 * 1]", "1", "pi / 2"],
    answer: "[(n-1)(n-3)...2] / [n(n-2)...3 * 1]"
  },
  {
    id: 669,
    question: "Which gas is responsible for the greenhouse effect and global warming most significantly?",
    options: ["Carbon dioxide", "Methane", "Water vapor", "Nitrous oxide"],
    answer: "Carbon dioxide"
  },
  {
    id: 670,
    question: "What is the induced EMF in a coil rotating in a uniform magnetic field maximum when?",
    options: ["Flux is maximum", "Flux is zero (rate of change of flux is maximum)", "Plane of coil is perpendicular to magnetic field", "Zero speed"],
    answer: "Flux is zero (rate of change of flux is maximum)"
  },
  {
    id: 671,
    question: "If A is a skew-symmetric matrix of odd order, what is its determinant?",
    options: ["1", "-1", "0", "Undefined"],
    answer: "0"
  },
  {
    id: 672,
    question: "Which reagent is used to convert an alkyne to a cis-alkene (Lindlar's catalyst)?",
    options: ["H2 / Pd-BaSO4", "Na in liquid NH3", "Zn / HCl", "LiAlH4"],
    answer: "H2 / Pd-BaSO4"
  },
  {
    id: 673,
    question: "What is the dimensional formula of gravitational potential?",
    options: ["[M L^2 T^-2]", "[M^0 L^2 T^-2]", "[M L T^-2]", "[M^-1 L^2 T^-2]"],
    answer: "[M^0 L^2 T^-2]"
  },
  {
    id: 674,
    question: "What is the sum of deviations of all values of a data set from its mean?",
    options: ["Always zero", "Always positive", "Always negative", "Depends on data"],
    answer: "Always zero"
  },
  {
    id: 675,
    question: "Which of the following compounds gives a positive carbylamine test?",
    options: ["Primary amine", "Secondary amine", "Tertiary amine", "Quaternary ammonium salt"],
    answer: "Primary amine"
  },
  {
    id: 676,
    question: "What is the polarizing angle (Brewster's angle) related to refractive index n by?",
    options: ["tan(ip) = n", "sin(ip) = n", "cos(ip) = n", "cot(ip) = n"],
    answer: "tan(ip) = n"
  },
  {
    id: 677,
    question: "What is the value of i^2026 where i = sqrt(-1)?",
    options: ["1", "-1", "i", "-i"],
    answer: "-1"
  },
  {
    id: 678,
    question: "Which oxide of nitrogen is known as laughing gas?",
    options: ["NO", "NO2", "N2O", "N2O5"],
    answer: "N2O"
  },
  {
    id: 679,
    question: "What is the formula for the radius of the n-th Bohr orbit in hydrogen atom?",
    options: ["r_n = 0.529 * n^2 Å", "r_n = 0.529 * n Å", "r_n = 0.529 * (n^2 / Z) Å", "r_n = 0.529 * (Z / n^2) Å"],
    answer: "r_n = 0.529 * (n^2 / Z) Å"
  },
  {
    id: 680,
    question: "What is the derivative of sec(x) with respect to x?",
    options: ["sec(x) * tan(x)", "-sec(x) * tan(x)", "csc(x) * cot(x)", "sec^2(x)"],
    answer: "sec(x) * tan(x)"
  },
  {
    id: 681,
    question: "Which element is the most abundant in Earth's crust by mass?",
    options: ["Silicon", "Aluminum", "Iron", "Oxygen"],
    answer: "Oxygen"
  },
  {
    id: 682,
    question: "What is the resonant frequency of an L-C-R series AC circuit?",
    options: ["1 / (2 * pi * sqrt(LC))", "2 * pi * sqrt(LC)", "sqrt(LC) / (2 * pi)", "1 / sqrt(LC)"],
    answer: "1 / (2 * pi * sqrt(LC))"
  },
  {
    id: 683,
    question: "If the lines (x-1)/2 = (y-2)/3 = (z-3)/4 and (x-4)/5 = (y-1)/2 = z/k are perpendicular, what is k?",
    options: ["-4", "4", "2", "-2"],
    answer: "-4"
  },
  {
    id: 684,
    question: "Which of the following is a condensation polymer formed from ethylene glycol and terephthalic acid?",
    options: ["Nylon 6,6", "Terylene (Dacron)", "Bakelite", "Buna-N"],
    answer: "Terylene (Dacron)"
  },
  {
    id: 685,
    question: "What is the dimensional formula of coefficient of viscosity?",
    options: ["[M L^-1 T^-1]", "[M L T^-1]", "[M L^-1 T^-2]", "[M^0 L^2 T^-2]"],
    answer: "[M L^-1 T^-1]"
  },
  {
    id: 686,
    question: "What is the value of limit as x approaches 0 of (1 + x)^(1/x)?",
    options: ["1", "e", "0", "Infinity"],
    answer: "e"
  },
  {
    id: 687,
    question: "Which compound is used as a standard reference in NMR spectroscopy?",
    options: ["Tetramethylsilane (TMS)", "Chloroform", "Benzene", "Acetone"],
    answer: "Tetramethylsilane (TMS)"
  },
  {
    id: 688,
    question: "What is the maximum torque acting on a current-carrying loop in a uniform magnetic field?",
    options: ["NIAB", "NIAB / 2", "Zero", "IAB^2"],
    answer: "NIAB"
  },
  {
    id: 689,
    question: "What is the integral of 1 / sqrt(x^2 - a^2) dx?",
    options: ["ln|x + sqrt(x^2 - a^2)| + C", "sin^-1(x/a) + C", "1/a * tan^-1(x/a) + C", "ln|x + sqrt(x^2 + a^2)| + C"],
    answer: "ln|x + sqrt(x^2 - a^2)| + C"
  },
  {
    id: 690,
    question: "Which halide of phosphorus is prepared by the action of white phosphorus on thionyl chloride?",
    options: ["PCl3", "PCl5", "Both PCl3 and PCl5", "None"],
    answer: "PCl3"
  },
  {
    id: 691,
    question: "What is the unit of electric field intensity?",
    options: ["Volt * meter", "Newton / Coulomb", "Coulomb / meter", "Joule / Coulomb"],
    answer: "Newton / Coulomb"
  },
  {
    id: 692,
    question: "If A and B are symmetric matrices of the same order, what is AB - BA always?",
    options: ["Symmetric matrix", "Skew-symmetric matrix", "Zero matrix", "Identity matrix"],
    answer: "Skew-symmetric matrix"
  },
  {
    id: 693,
    question: "Which of the following compounds has the highest boiling point?",
    options: ["n-Pentane", "Isopentane", "Neopentane", "All have same boiling point"],
    answer: "n-Pentane"
  },
  {
    id: 694,
    question: "What is the formula for the radius of a nucleus of mass number A?",
    options: ["R = R_0 * A^(1/3)", "R = R_0 * A", "R = R_0 * A^3", "R = R_0 / A^(1/3)"],
    answer: "R = R_0 * A^(1/3)"
  },
  {
    id: 695,
    question: "What is the value of int from 0 to pi/2 of cos^n(x) dx when n is an even integer?",
    options: ["[(n-1)(n-3)...1] / [n(n-2)...2] * (pi/2)", "[(n-1)(n-3)...1] / [n(n-2)...2]", "1", "pi / 2"],
    answer: "[(n-1)(n-3)...1] / [n(n-2)...2] * (pi/2)"
  },
  {
    id: 696,
    question: "Which gas is released when bleaching powder reacts with dilute acids?",
    options: ["Oxygen", "Chlorine", "Hydrogen", "Carbon dioxide"],
    answer: "Chlorine"
  },
  {
    id: 697,
    question: "What is the de Broglie wavelength associated with an alpha particle accelerated through a potential difference V?",
    options: ["h / sqrt(8meV)", "h / sqrt(2meV)", "h / sqrt(4meV)", "h / sqrt(me V)"],
    answer: "h / sqrt(8meV)"
  },
  {
    id: 698,
    question: "What is the slope of the normal to the curve y = x^2 - 3x + 2 at x = 1?",
    options: ["-1", "1", "1 / infinity", "0"],
    answer: "1"
  },
  {
    id: 699,
    question: "Which reagent is used in the Reimer-Tiemann reaction to convert phenol to salicylaldehyde?",
    options: ["Chloroform and aqueous NaOH", "Carbon tetrachloride and NaOH", "Methyl chloride and AlCl3", "Acetyl chloride"],
    answer: "Chloroform and aqueous NaOH"
  },
  {
    id: 700,
    question: "What is the SI unit of magnetic flux density (B)?",
    options: ["Weber", "Tesla", "Henry", "Ampere-meter"],
    answer: "Tesla"
  }
];